import { config } from 'env_def';
import { api } from '@/api/api';
import { apis, environment, externalJumpUrls, ignoreLoginPath, inWindow, jumpLogin, loginPageExt } from '@/config';
import { ErrMsgCodeMap } from '@/api/errMap';
import { globalStoreConfig } from '@/api/data/store';
import { getCurrentPageEnv, getReLoginUpTime, pathNotInArrJudge, util, wait } from '@/api/util';
import { getIsLoginPage, getIsJumpPage } from '../../../utils/isLocPage';
import { transferLocalDeviceToServerDevice, transferCWServiceDeviceInfoToLocalDevice, transferLocalDeviceToCWServerDevice, transferServerDeviceToLocalDevice, } from '../../../utils/sec-device-transfer';
import loginUtils from './login_utils';
import corpLoginUtils from './login_corp_utils';
import account from '@/api/data/tables/account';
import { locationHelper } from '@/api/util/location_helper';
import { SUB_ACCOUNT_TYPES, SUB_ACCOUNT_ERRCODE_MAPS, DEFAULT_API_ERROR, DEFAULT_BIND_ACCOUNT_ERR, SEND_CODE_DEFAULT_ERROR, SELF_UNBLOCK_DEFAULT_ERROR, SUBACCOUNT_LOGINTYPE, EDM_LOGOUT_DEVICE_KEY, LINGXI_LOGOUT_DEVICE_KEY, } from './login_const';
import { checkMasterInfo } from '@mail/jmail';
const noHeaderTokenConfig = {
    noHeaderCookie: true,
};
const profile = config('profile');
const RiskPrefix = config('webMailBJHost');
const isWebmail = profile && profile.startsWith('webmail');
let productCode = 'sirius';
if (isWebmail) {
    productCode = 'web';
}
else if (inWindow() && window.electronLib) {
    productCode = 'sirius';
}
else {
    productCode = 'web';
}
const NO_LOGIN_RIGHTS_CODE = 'LOGIN.PERMDENY';
const LOGIN_EXCLUDECOOKIE = 'QIYE_SESS,QIYE_TOKEN,mail_idc,Coremail,mCoremail,qiye_uid,fewmgray';
const LOGIN_AUTHRESPONSECOOKIES = 'token,refreshToken,sid,coremail,mCoremail,sess';
const SEC_DEVICE_LOGOUT_CODE = 'LOGIN.SEC.PERMDENY';
const SUB_ACCOUNT_EXCLUDECOOKIE = 'fewmgray';
const MIN_SUBACCOUNT_AUTOLOGIN_SPAN_TIME = 60 * 1000;
const MAX_SUBACCOUNT_AUTOLOGIN_COUNT = 10;
const DEFAULT_CHECK_DEVICE_INTERVAL = 1440;
const CHECK_DEVICE_INTERVAL_DBKEY = 'CHECK_DEVICE_INTERVAL_DBKEY';
let lastCheckDeviceTs = 0;
const PUSH_PRODUCT = process.env.BUILD_ISEDM ? 'waimao' : 'sirius';
const subAccountLoginInfo = {};
let lastBindDeviceAccountTs = 0;
const defaultLoginInfo = {
    hl: 'zh_CN',
    all_secure: 1,
    secure: 1,
    deviceid: '--',
    p: productCode,
    support_verify_code: 1,
    output: 'json',
};
const defaultPreLoginInfo = {
    p: productCode,
    output: 'json',
};
const defaultLoginDoor = {
    p: productCode,
    hl: 'zh_CN',
    uid: '',
    all_secure: 1,
    output: 'json',
    origin: '',
};
const PassWordTypeMap = {
    plain: 1,
    md5: 2,
    rsa: 3,
};
const QrCheckStatus = {
    init: 0,
    scaning: 1,
    pass: 2,
    expire: 3,
};
const COMMON_WEB_HEADER = {
    'Qiye-Header': 'sirius',
};
const defauleNode = 'hz';
class ActionStore {
    constructor() {
        this.subAccountCurrentPreLoginRequestMap = {};
        this.currentSubAccountPreLoginResponse = {};
        this.preLoginPassed = false;
        this.currentLoginRisk = {};
        this.currentNode = defauleNode;
        this.subAccountNodeMap = {};
        this.keyOfAccount = '';
        this.currentAccount = undefined;
        this.currentSubAccount = {};
        this.codeRetryTime = 0;
        this.loginMethod = 'pass';
        this.subAccountLoginMethodMap = {};
        this.autoLogin = false;
        this.subAccountAutoLoginMap = {};
        this.logout = false;
        this.subAccountLogoutMap = {};
        this.mailMode = loginUtils.getDefaulaMailModeVal();
        this.corpSid = '';
        this.unqCode = '';
        this.currentAccountPwd = '';
        this.loginIssueConfirmShowed = false;
        this.currentWillLoginAccount = '';
        this.currentWillLoginSubAccount = '';
        this.bindSubAccountInfo = {};
        this.bindSubAccountCookieMapInfo = {};
    }
}
const debugSecCert = false;
class LoginApiImpl {
    constructor() {
        this.subAccountBindInfo = null;
        this.changeHashUrl = /^#\/?((?:doc)|(?:sheet)|(?:share)|(?:unitable))/i;
        this.encryptedPwdHead = 'encrypted:[';
        this.encryptedPwdTail = ']';
        this.autoFillPwdMd5 = '';
        this.subAccountNoLoginStatusMap = {};
        this.subAccountLogoutProcessingMap = {};
        this.addAccountEventId = 0;
        this.sysMacDeviceInfo = null;
        this.noLoginEvent = false;
        this.hasWatchResumeAndOnline = false;
        this.needCheckSecCert = debugSecCert || (process.env.BUILD_ISELECTRON && process.env.BUILD_ISLINGXI);
        this.impl = api.getDataTransApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.actions = new ActionStore();
        this.eventApi = api.getEventApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.dataTrackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.name = apis.loginApiImpl;
        this.noLoginStatus = false;
        this.logoutProcessing = false;
        this.productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
    }
    unpackLoginData(res) {
        var _a;
        console.log('[login] return from network:' + ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code), JSON.stringify(res.data), JSON.stringify(res.config.data));
        this.loggerApi.track('login_request_returned', { res });
        const data = res.data;
        return data;
    }
    static commonCatch(reason) {
        if (reason instanceof Error) {
            return LoginApiImpl.getErrMsg(reason.message);
        }
        if (typeof reason === 'string') {
            return LoginApiImpl.getErrMsg(reason);
        }
        return LoginApiImpl.defaultErrInfo;
    }
    static getErrMsgCode(errCode) {
        if (errCode) {
            if (errCode === NO_LOGIN_RIGHTS_CODE && inWindow() && window.electronLib) {
                return 'LINGXI.LOGIN.PERMDENY';
            }
        }
        return errCode;
    }
    static getErrMsg(errMsg, defaultMsg) {
        if (errMsg && errMsg in ErrMsgCodeMap) {
            const errCode = LoginApiImpl.getErrMsgCode(errMsg);
            return ErrMsgCodeMap[errCode] || ErrMsgCodeMap[errMsg];
        }
        return errMsg || defaultMsg || LoginApiImpl.defaultErrInfo;
    }
    handleAccountAndDomain(account) {
        return this.systemApi.handleAccountAndDomain(account);
    }
    getUrl(url, email) {
        let node;
        if (!email) {
            node = this.actions.currentNode || this.storeApi.getCurrentNode();
        }
        else {
            node = this.actions.subAccountNodeMap[email] || this.storeApi.getCurrentNode(email) || defauleNode;
        }
        return this.systemApi.getUrl(url, node);
    }
    async loadStorageToDB() {
        try {
            return true;
        }
        catch (e) {
            console.error('[login] loadStorageToDB error', e);
            return false;
        }
    }
    fillAutoEntryAndNoCookieInfo(req) {
        if (req && process.env.BUILD_ISWEB) {
            req.autoEntry = true;
            req.excludeCookie = LOGIN_EXCLUDECOOKIE;
            req.authResponse = LOGIN_AUTHRESPONSECOOKIES;
        }
    }
    getSecLoginInfo() {
        if (!process.env.BUILD_ISELECTRON)
            return {};
        if (!this.sysMacDeviceInfo)
            return {};
        return Object.assign(Object.assign({}, this.sysMacDeviceInfo), { sec: true });
    }
    isPreloginNeedUpdate(req) {
        if (req.code) {
            return true;
        }
        const { email, account } = req;
        const { currentPreloginRequest, preLoginPassed, currentPreloginResponse, currentLoginRisk } = this.actions;
        if (preLoginPassed && currentPreloginResponse && currentPreloginRequest) {
            if (currentPreloginRequest.type === 1) {
                return !(req.mobile === currentPreloginRequest.mobile && req.sendCodeType === currentPreloginRequest.sendCodeType);
            }
            if (email && currentLoginRisk[email]) {
                delete this.actions.currentLoginRisk[email];
                return true;
            }
            if (account && currentLoginRisk[account]) {
                delete this.actions.currentLoginRisk[account];
                return true;
            }
            return !(req.domain === currentPreloginRequest.domain && req.account_name === currentPreloginRequest.account_name);
        }
        return true;
    }
    preLoginCheck(account) {
        return this.impl
            .get(this.getUrl('newPreLoginCheck') + '?email=' + account)
            .then((rs) => {
            const resData = rs.data;
            if (!(resData === null || resData === void 0 ? void 0 : resData.data)) {
                return false;
            }
            return resData.data;
        })
            .catch(reason => {
            console.log('[login] pre login check error', reason);
            return true;
        });
    }
    getUseSessionInfo(sessionName, setSessioName) {
        const ret = {};
        if (process.env.BUILD_ISELECTRON) {
            if (sessionName) {
                ret._session = sessionName;
            }
            if (setSessioName) {
                ret._setsession = setSessioName;
            }
        }
        return ret;
    }
    async preLogin(req) {
        var _a;
        const isSubAccount = !!req.isSubAccount;
        if (!isSubAccount && !this.isPreloginNeedUpdate(req)) {
            return Promise.resolve(this.actions.currentPreloginResponse);
        }
        const type = req.type || 0;
        let rs = true;
        const isEmailPreLogin = type === 0;
        if (isEmailPreLogin) {
            rs = await this.preLoginCheck('a@' + req.domain);
        }
        if (rs) {
            if (!isSubAccount) {
                this.actions.currentPreloginRequest = req;
            }
            else if (req.email) {
                this.actions.subAccountCurrentPreLoginRequestMap[req.email] = req;
            }
            const isNeteaseDomain = corpLoginUtils.getIsNeteaseDomain(req.domain);
            const preLoginUrlKey = isNeteaseDomain ? 'corpPreLogin' : 'preLogin';
            let reqUrl = this.getUrl(preLoginUrlKey, isSubAccount ? req.email : undefined);
            if (isSubAccount && req.sessionName) {
                const sessionInfo = this.getUseSessionInfo(req.sessionName, req.sessionName);
                reqUrl = this.impl.buildUrl(reqUrl, sessionInfo);
            }
            if (isSubAccount && process.env.BUILD_ISEDM) {
                reqUrl = this.impl.buildUrl(reqUrl, { excludeCookie: SUB_ACCOUNT_EXCLUDECOOKIE });
            }
            const data = await this.impl.post(reqUrl, req);
            const res = this.unpackLoginData(data);
            const { actions } = this;
            const mailMode = loginUtils.getMaiModeFromPreLoginResponse(res);
            if (!isSubAccount) {
                actions.mailMode = mailMode;
            }
            const isCorpMailMode = loginUtils.getIsCorpMailMode(mailMode);
            const reqEmail = req.email || '';
            if ((String(res.code) === '200' && !res.data.verify_code) || (String(res.code) === '404' && this.getShouldIgnoreNodeError(res.data, res.msgCode))) {
                res.data.err = false;
                if (!isSubAccount) {
                    actions.preLoginPassed = true;
                    actions.currentPreloginResponse = res.data;
                    if (isCorpMailMode) {
                        actions.corpSid = (_a = res.data) === null || _a === void 0 ? void 0 : _a.sid;
                    }
                }
                else {
                    actions.currentSubAccountPreLoginResponse[reqEmail] = res.data;
                }
                res.data.isSubAccount = isSubAccount;
                res.data.sessionName = req.sessionName;
                res.data.email = reqEmail;
                return res.data;
            }
            if (!isSubAccount) {
                actions.preLoginPassed = false;
                actions.currentPreloginResponse = undefined;
                if (isCorpMailMode) {
                    actions.corpSid = '';
                }
            }
            else {
                actions.currentSubAccountPreLoginResponse[reqEmail] = {};
            }
            if (!res.data) {
                res.data = {};
            }
            res.data.isSubAccount = isSubAccount;
            res.data.sessionName = req.sessionName;
            res.data.email = reqEmail;
            res.data.err = true;
            res.data.errmsg = res.data.verify_code ? LoginApiImpl.getErrMsg('ERR.CODE.INVALID') : LoginApiImpl.getErrMsg(res.msgCode);
            return res.data;
        }
        return Promise.resolve({
            err: true,
            errmsg: ErrMsgCodeMap['ERR.LOGIN.DOMAINDENY'],
        });
    }
    doPreLogin(account, isSubAccount, sessionName, code) {
        var _a;
        const dna = this.handleAccountAndDomain(account);
        if (!loginUtils.checkAccountAndDomain(dna)) {
            return Promise.resolve(loginUtils.getInputEmailErrorMsg());
        }
        const req = Object.assign(Object.assign({}, defaultPreLoginInfo), { account, account_name: dna.account, domain: dna.domain, mobile: (_a = this.actions.currentPreloginRequest) === null || _a === void 0 ? void 0 : _a.mobile, isSubAccount: !!isSubAccount, sessionName: sessionName || '', email: account, code: code || '' });
        return this.preLogin(req).then(this.handlePreLoginData.bind(this)).catch(LoginApiImpl.commonCatch);
    }
    async doMobilePreLogin(mobile, sendCodeType = 1) {
        try {
            const res = await this.preLogin(Object.assign(Object.assign({}, defaultPreLoginInfo), { mobile, type: 1, sendCodeType }));
            return this.handlePreLoginData(res);
        }
        catch (e) {
            return LoginApiImpl.commonCatch(e);
        }
    }
    getIsAllowNode(node) {
        const allowNodes = ['hz', 'bj'];
        return allowNodes.includes(node);
    }
    getShouldIgnoreNodeError(rs, msgCode) {
        if (msgCode && msgCode !== 'PRELOGIN.NOTFOUND') {
            return false;
        }
        if (rs && rs.modulus && rs.rand && rs.exponent) {
            return true;
        }
        return false;
    }
    handlePreLoginData(rs) {
        if (rs.locked) {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventData: ErrMsgCodeMap.EXP_AUTH_USER_STATUS_LOCKED,
                eventSeq: 0,
                eventStrData: 'warn',
            });
            return Promise.reject(new Error('prelogin fail , account locked'));
        }
        const isSubAccount = !!rs.isSubAccount;
        const reqEmail = rs.email || '';
        if (rs.node) {
            if (!this.getIsAllowNode(rs.node)) {
                return {
                    errMsg: `不支持的节点${rs.node}`,
                    err: true,
                };
            }
            if (this.getShouldIgnoreNodeError(rs)) {
                if (isSubAccount) {
                    this.actions.subAccountNodeMap[reqEmail] = rs.node;
                }
                else {
                    this.actions.currentNode = rs.node;
                }
                rs.node = '';
            }
        }
        if (rs.node) {
            if (!isSubAccount) {
                this.actions.preLoginPassed = false;
                this.actions.currentPreloginResponse = undefined;
            }
            else {
                this.actions.currentSubAccountPreLoginResponse[reqEmail] = {};
            }
            const currentActionNode = !isSubAccount ? this.actions.currentNode : this.actions.subAccountNodeMap[reqEmail] || defauleNode;
            if (currentActionNode !== rs.node) {
                if (!this.getIsAllowNode(rs.node)) {
                    return {
                        errMsg: `不支持的节点${rs.node}`,
                        err: true,
                    };
                }
                this.setupNodeInfo(rs.node, false, isSubAccount ? reqEmail : undefined).then();
                const { account, mobile, type = 'mail' } = !isSubAccount ? this.actions.currentPreloginRequest : { account: reqEmail, mobile: '' };
                if (type === 'mail') {
                    return this.doPreLogin(account, isSubAccount, rs.sessionName);
                }
                return this.doMobilePreLogin(mobile);
            }
            return LoginApiImpl.defaultErrInfo;
        }
        const currentNode = isSubAccount ? this.actions.subAccountNodeMap[reqEmail] : this.actions.currentNode;
        this.setupNodeInfo(currentNode, false, isSubAccount ? reqEmail : undefined).then();
        const errMsg = rs.errmsg ? LoginApiImpl.getErrMsg(rs.errmsg) : '';
        if (errMsg) {
            rs.err = true;
            rs.errmsg = errMsg;
        }
        else {
            rs.isCorpMailMode = loginUtils.getIsCorpMailMode(this.actions.mailMode);
            rs.sid = this.actions.corpSid;
        }
        return rs;
    }
    async setupNodeInfo(node, noEvent, email) {
        if (!email) {
            this.actions.currentNode = node;
            this.storeApi.setCurrentNode(node);
        }
        else {
            this.actions.subAccountNodeMap[email] = node;
            this.storeApi.setCurrentNode(node, email);
        }
        if (!noEvent) {
            const ev = {
                eventName: 'preLogin',
                eventData: node,
                eventSeq: 0,
                eventStrData: 'warn',
            };
            await (this.eventApi.sendSysEvent(ev) || Promise.resolve());
        }
    }
    disableBackgroundDB(removeSubPage) {
        try {
            if (inWindow() && window.bridgeApi && window.bridgeApi.master) {
                window.bridgeApi.master.forbiddenBbWin4CurrPage();
                if (!this.systemApi.isElectron() && removeSubPage) {
                    window.bridgeApi.master.removeSubPageInWeb();
                }
            }
            if (process.env.BUILD_ISELECTRON) {
                window.electronLib.masterBridgeManage.flush('');
            }
        }
        catch (ex) {
            console.error('diableBackgroundDBWin', ex);
        }
    }
    enableBackgroundDB() {
        try {
            const isLowMemoryMode = this.systemApi.getIsLowMemoryModeSync();
            if (isLowMemoryMode) {
                return;
            }
            if (inWindow() && window.bridgeApi && window.bridgeApi.master) {
                window.bridgeApi.master.enableBbWin4CurrPage();
            }
        }
        catch (ex) {
            console.error('enableBackgroundDB', ex);
        }
    }
    async doAutoLogin(account, noLoginEvent, noEnableBackDb) {
        var _a;
        const tid = setTimeout(() => {
            if (environment === 'prod') {
                util.reload();
            }
        }, 95000);
        try {
            this.noLoginEvent = !!noLoginEvent;
            if (!this.isSameAccount(account) && !this.systemApi.isBkLoginInit()) {
                await this.doLogout(true, true);
            }
            console.log('[login] finish logout !!!!!- ');
            if (this.systemApi.isElectron() && window.electronLib) {
                const storedAccount = await this.getAccountStored(account);
                if (loginUtils.getIsCorpMailMode((_a = storedAccount === null || storedAccount === void 0 ? void 0 : storedAccount.prop) === null || _a === void 0 ? void 0 : _a.mailMode)) {
                    await window.electronLib.appManage.clearCookieStore();
                }
                const cookies = storedAccount === null || storedAccount === void 0 ? void 0 : storedAccount.cookies;
                if (cookies && cookies.length > 0) {
                    try {
                        if (this.systemApi.isBkLoginInit()) {
                            const currentSessionName = this.systemApi.getCurrentSessionName();
                            await window.electronLib.appManage.setCookieStore({
                                cookies,
                                sessionName: currentSessionName || '',
                            });
                        }
                        else {
                            await window.electronLib.appManage.setCookieStore(cookies);
                        }
                        console.log('[login]  finish seting cookies !!!!!- ', cookies);
                    }
                    catch (e) {
                        console.warn('[login] setCookieStore error', e);
                    }
                }
            }
            const res = await this.autoLogin(account, false, noEnableBackDb);
            return res;
        }
        catch (e) {
            return { pass: false, errmsg: LoginApiImpl.commonCatch(e) || '未知错误' };
        }
        finally {
            this.noLoginEvent = false;
            clearTimeout(tid);
        }
    }
    async corpAutoLogin(accountInfo) {
        const timeStampStr = Math.floor(new Date().getTime() / 1000).toString();
        const requestData = {
            account_name: accountInfo.accountName,
            domain: accountInfo.domain,
            sid: accountInfo.sessionId,
            accessToken: accountInfo.accessToken,
            timestamp: timeStampStr,
            signature: corpLoginUtils.getSignForCorpRenewSid(accountInfo.accessToken, accountInfo.accessSecret, timeStampStr),
        };
        const reNewSidUrl = this.getUrl('corpMailRenewSid');
        return this.impl
            .post(reNewSidUrl, requestData)
            .then(res => res.data)
            .then(res => {
            const resCode = String(res === null || res === void 0 ? void 0 : res.code);
            if (resCode === corpLoginUtils.CONSTANTS.CORP_API_SUCCESS_CODE) {
                return {
                    pass: true,
                    res: res === null || res === void 0 ? void 0 : res.data,
                };
            }
            return {
                pass: false,
                errmsg: LoginApiImpl.getErrMsg(res === null || res === void 0 ? void 0 : res.msgCode),
                res,
            };
        })
            .then(async (rs) => {
            var _a;
            if (rs.pass) {
                const email = accountInfo.accountName + '@' + accountInfo.domain;
                const newSid = (_a = rs.res) === null || _a === void 0 ? void 0 : _a.sid;
                const newUser = await this.corpGetNewUserWithNewSid(email, newSid);
                if (newUser) {
                    const loginData = corpLoginUtils.getResponseLoginDataFromUser(newUser);
                    await this.corpLoginSucceed(loginData);
                }
                else {
                    rs.pass = false;
                }
            }
            return rs;
        })
            .catch(err => {
            if (err && typeof err === 'string' && err === 'NETWORK.ERR.TIMEOUT') {
                return {
                    pass: false,
                    timeout: true,
                    errmsg: '请求超时',
                };
            }
            return {
                pass: false,
                errmsg: LoginApiImpl.commonCatch(err),
            };
        });
    }
    isSameAccount(account) {
        const currentUser = this.systemApi.getCurrentUser();
        return account === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    }
    logSubAccountAutoLoginInfo(agentAccount, currentUser) {
        try {
            if (subAccountLoginInfo) {
                const accountLoginInfo = subAccountLoginInfo[agentAccount];
                if (!accountLoginInfo) {
                    subAccountLoginInfo[agentAccount] = {
                        agentEmail: agentAccount,
                        lastLoginTime: new Date().getTime(),
                        autoLoginCount: 1,
                    };
                }
                else {
                    const nowTs = new Date().getTime();
                    const trackAttr = { agentEmail: agentAccount, mainAccount: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id };
                    if (nowTs - accountLoginInfo.lastLoginTime < MIN_SUBACCOUNT_AUTOLOGIN_SPAN_TIME) {
                        this.dataTrackApi.track('subAccount_autoLogin_too_freq', trackAttr);
                    }
                    if (accountLoginInfo.autoLoginCount >= MAX_SUBACCOUNT_AUTOLOGIN_COUNT) {
                        this.dataTrackApi.track('subAccount_autoLogin_count_limit', trackAttr);
                    }
                    accountLoginInfo.lastLoginTime = nowTs;
                    accountLoginInfo.autoLoginCount++;
                }
            }
        }
        catch (ex) {
            console.error('logSubAccountAutoLoginInfo-error', ex);
        }
    }
    async doSubAccountAutoLogin(_account, relationType) {
        try {
            const agentAccount = _account;
            if (!agentAccount) {
                return {
                    pass: false,
                    errmsg: '无子账号',
                };
            }
            const currentUser = this.systemApi.getCurrentUser();
            this.logSubAccountAutoLoginInfo(agentAccount, currentUser);
            const isQiyeMail = relationType === 0;
            const res = await this.loginAgentEmail(agentAccount, process.env.BUILD_ISWEB ? '' : 'persist:sirius', process.env.BUILD_ISWEB ? '' : this.getSessionNameOfSubAccount(agentAccount, currentUser ? currentUser.id : ''), isQiyeMail ? SUBACCOUNT_LOGINTYPE.NETEASE_QIYE_MAIL : SUBACCOUNT_LOGINTYPE.OTHERS);
            return {
                pass: res.success,
                errmsg: res.errMsg || '',
            };
        }
        catch (ex) {
            console.error('doSubAccountAutoLogin-error', ex);
            return {
                pass: false,
                errmsg: ex.mesage || '子账号登录接口出错',
            };
        }
    }
    async autoLogin(_account, isSubAccount, noEnableBackDb) {
        var _a;
        try {
            const loginAccount = await this.getAccountStored(_account, isSubAccount);
            console.warn('[login autoLogin] account', loginAccount, this.systemApi.getCurrentUser(_account));
            if (!loginAccount) {
                return {
                    errmsg: '本地无登录账号',
                    pass: false,
                };
            }
            const sessionName = !isSubAccount ? '' : this.systemApi.getSessionNameOfSubAccount(loginAccount.id);
            this.loggerApi.track('login_start_autoLogin', { loginAccount });
            const { refreshToken, refreshTokenExpire, id, pwd, prop, loginAccount: willLoginAccount } = loginAccount;
            console.log('[login] re login using account info:', loginAccount);
            if (window.isBridgeWorker) {
                this.systemApi.closeWindow(false, true);
            }
            if (isSubAccount && _account) {
                const isThirdAccount = this.systemApi.getIsThirdSubAccountByEmailId(_account);
                return this.doSubAccountAutoLogin(loginAccount.agentEmail, isThirdAccount ? SUBACCOUNT_LOGINTYPE.OTHERS : SUBACCOUNT_LOGINTYPE.NETEASE_QIYE_MAIL);
            }
            const accountMailMode = prop === null || prop === void 0 ? void 0 : prop.mailMode;
            if (!isSubAccount && loginUtils.getIsCorpMailMode(accountMailMode)) {
                const params = corpLoginUtils.getCorpAutoLoginParams(loginAccount);
                return this.corpAutoLogin(params);
            }
            const { account: account_name, domain } = this.handleAccountAndDomain(willLoginAccount || id);
            let res;
            if (refreshToken && refreshTokenExpire) {
                pwd && this.storePwd(pwd, 2, isSubAccount, isSubAccount ? _account : undefined);
                this.loggerApi.track('login_doRefreshTokenLogin_autoLogin', {
                    loginAccount,
                });
                res = await this.doRefreshTokenLogin({
                    tokenExpire: refreshTokenExpire || 0,
                    token: refreshToken || '',
                    account_name,
                    domain,
                    isSubAccount,
                    noEnableBackDb,
                    isAutoLogin: true,
                });
                if (res.pass) {
                    return res;
                }
            }
            if (pwd && pwd !== LoginApiImpl.accountPwdAutoFilled && pwd !== this.autoFillPwdMd5) {
                this.loggerApi.track('login_pwd_autoLogin', { loginAccount });
                this.dataTrackApi.track('auto_login_use_pwd', { loginAccount });
                return this.doLogin({
                    account: id,
                    isAutoLogin: true,
                    pwd: LoginApiImpl.accountPwdAutoFilled,
                    isSubAccount: !!isSubAccount,
                    sessionName,
                    noEnableBackDb,
                }, (res === null || res === void 0 ? void 0 : res.timeout) ? 1 : 2);
            }
            this.dataTrackApi.track('auto_login_no_pwd', { loginAccount });
            return {
                pass: false,
                errmsg: '无登录账号信息',
            };
        }
        catch (e) {
            console.warn('[login] error occured when autoLogin:', e);
            return {
                errmsg: ((_a = e) === null || _a === void 0 ? void 0 : _a.msg) || '预登录接口发生未知错误',
                pass: false,
            };
        }
    }
    async getAccountStored(currentAccountId, isSubAccount = false) {
        let accountId = currentAccountId;
        const currentUser = this.systemApi.getCurrentUser();
        if (!accountId) {
            accountId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
        }
        if (accountId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSharedAccount)) {
            return currentUser;
        }
        if (accountId) {
            const accountList = await this.accountApi.doGetAccountInfo([accountId], isSubAccount);
            return accountList[0];
        }
        return undefined;
    }
    async corpLoginSucceed(res, beforeUserInfo) {
        var _a, _b;
        let user = null;
        if (beforeUserInfo) {
            user = beforeUserInfo;
        }
        await this.loginSucceed({
            isCorpMail: true,
            uid: res.uid,
            nickname: res.nickname || (user === null || user === void 0 ? void 0 : user.nickName),
            cookieName: res.sid,
            orgName: res.orgName || (user === null || user === void 0 ? void 0 : user.company),
            cnName: res.cookieName,
            accessToken: res.accessToken || ((_a = user === null || user === void 0 ? void 0 : user.prop) === null || _a === void 0 ? void 0 : _a.accessToken),
            accessSecret: res.accessSecret || ((_b = user === null || user === void 0 ? void 0 : user.prop) === null || _b === void 0 ? void 0 : _b.accessSecret),
            nonce: res.nonce,
            mobile: res.mobile,
        });
    }
    async corpGetNewUserWithNewSid(email, newSid) {
        try {
            const accountUser = await this.getAccountStored(email);
            if (!accountUser) {
                return null;
            }
            accountUser.sessionId = newSid;
            return accountUser;
        }
        catch (ex) {
            console.error('[login] corpReNewSidSucceed', ex);
            return null;
        }
    }
    async clearCookies(shouldDeleteAllCookies = false) {
        try {
            if (this.systemApi.isElectron() && window.electronLib) {
                return window.electronLib.windowManage.clearLocalData('cookies');
            }
            return this.systemApi.clearUserAuthCookie(false, shouldDeleteAllCookies);
        }
        catch (ex) {
            console.error('clearCookies error', ex);
            return Promise.resolve();
        }
    }
    async tryReportLoginSuccess(account) {
        if (process.env.BUILD_ISEDM)
            return;
        const logPrefix = '[login] report-error';
        try {
            if (!account)
                return;
            await this.requestReportSuccApi(account).catch(err => {
                console.error(logPrefix, err);
            });
        }
        catch (ex) {
            console.error(logPrefix, ex);
        }
    }
    async doCorpLogin(account, password, verifyCode) {
        const { corpSid } = this.actions;
        const accountInfo = this.handleAccountAndDomain(account);
        const corpParams = await corpLoginUtils.getRequestParamsAsync({
            sid: corpSid,
            account: accountInfo.account,
            domain: accountInfo.domain,
            deviceId: defaultLoginInfo.deviceid,
        });
        const beforeLoginInfo = await this.getAccountStored(account);
        let reloginParams = {};
        if (beforeLoginInfo) {
            reloginParams = corpLoginUtils.getReLoginParams(beforeLoginInfo);
        }
        const requestData = Object.assign(Object.assign(Object.assign(Object.assign({}, (reloginParams || {})), defaultLoginInfo), corpParams), { support_verify_code: 1, verify_code: verifyCode, password });
        const loginUrl = this.getUrl('corpMailPwdLogin');
        return this.impl
            .post(loginUrl, requestData)
            .then(res => res.data)
            .then(res => {
            const resCodeStr = String(res === null || res === void 0 ? void 0 : res.code);
            if (resCodeStr === corpLoginUtils.CONSTANTS.CORP_API_SUCCESS_CODE) {
                this.storeCurrentAccount({
                    account,
                    pwd: corpLoginUtils.CONSTANTS.CORP_DEFAULT_PASSWORD,
                });
                return res.data;
            }
            return {
                pass: false,
                err: true,
                errMsg: res === null || res === void 0 ? void 0 : res.msgCodeDesc,
                errCode: res === null || res === void 0 ? void 0 : res.msgCode,
            };
        })
            .then(res => this.handleLoginResponse(res))
            .then(async (rs) => {
            if (rs.pass) {
                await this.corpLoginSucceed(rs.res, beforeLoginInfo);
            }
            else if (rs.errCode === 'ERR.SESSIONNULL') {
                this.actions.preLoginPassed = false;
            }
            return rs;
        })
            .catch(err => {
            console.error('[login] doCorpLogin error:', err);
            return {
                errmsg: LoginApiImpl.commonCatch(err),
                pass: false,
            };
        });
    }
    addTestSecInfo(req) {
        req.p = 'sirius';
        req.secName = 'zoumingliangdeMacBook-Pro.local';
        req.secMdc = '14:7d:da:d1:45:56,2c:16:db:a8:35:93,ac:de:48:00:11:22';
        req.secOsType = 1;
        req.secOsDesc = '22.6.0';
        req.sec = true;
        req.secCert = true;
    }
    async doLogin(params, retry) {
        var _a, _b, _c;
        const { account, pwd, isAutoLogin, verifyCode, isUnLockApp = false, isSubAccount = false, sessionName, noEnableBackDb } = params;
        const dna = this.handleAccountAndDomain(account);
        if (!loginUtils.checkAccountAndDomain(dna)) {
            return {
                errmsg: loginUtils.getInputEmailErrorMsg(),
                pass: false,
            };
        }
        if (!isSubAccount && loginUtils.getIsCorpMailMode(this.actions.mailMode)) {
            return this.doCorpLogin(account, pwd, verifyCode);
        }
        let needPreLogin = false;
        if (!isSubAccount && !isAutoLogin) {
            needPreLogin = !this.actions.preLoginPassed;
        }
        if (needPreLogin) {
            const res = await this.doPreLogin(account, false, undefined, verifyCode);
            if (typeof res === 'object' && ((_a = res.errmsg) === null || _a === void 0 ? void 0 : _a.length)) {
                return {
                    errmsg: ErrMsgCodeMap['LOGIN.ILLEGAL.STATE'] + ':' + res.errmsg,
                    pass: false,
                };
            }
        }
        const { pwd: password, type } = await this.getS({
            originPwd: pwd,
            originAccount: account,
            rsaEncrypt: !isAutoLogin,
            md5Encrypt: isAutoLogin,
            isSubAccount,
            email: account,
        });
        const pubid = ((_b = (!isSubAccount ? this.actions.currentPreloginResponse : this.actions.currentSubAccountPreLoginResponse[account])) === null || _b === void 0 ? void 0 : _b.pubid) || '';
        const secCertInfo = await this.accountApi.doGetSecCertInfoById(account);
        const req = Object.assign(Object.assign({}, defaultLoginInfo), { passtype: PassWordTypeMap[type], account_name: dna.account, domain: dna.domain, password,
            pubid, verify_code: verifyCode, isSubAccount });
        if (type === 'rsa' && !pubid) {
            return {
                errmsg: ErrMsgCodeMap['PRELOGIN.ERR'],
                pass: false,
            };
        }
        this.storePwd(type === 'md5' ? password : pwd, PassWordTypeMap[type], isSubAccount, account);
        if (!isSubAccount) {
            this.actions.loginMethod = 'pass';
        }
        else {
            this.actions.subAccountLoginMethodMap[account] = 'pass';
        }
        if (!isSubAccount) {
            this.actions.currentWillLoginAccount = account;
        }
        else {
            this.actions.currentWillLoginSubAccount = account;
        }
        if (isUnLockApp) {
            req.sessionName = '';
            req.setSessionName = `memory-${new Date().getTime()}`;
        }
        else if (sessionName) {
            req.sessionName = sessionName;
        }
        try {
            this.fillSecRequestInfo(req);
            if (this.needCheckSecCert && !isAutoLogin) {
                req.secCert = true;
                if (debugSecCert) {
                    this.addTestSecInfo(req);
                }
                if (!isSubAccount && (secCertInfo === null || secCertInfo === void 0 ? void 0 : secCertInfo.sn) && (secCertInfo === null || secCertInfo === void 0 ? void 0 : secCertInfo.priKey)) {
                    req.secCertSn = secCertInfo.sn;
                    req.secCertTime = Date.now();
                    req.secCertSign = await this.getSeCertSign(Object.assign(Object.assign(Object.assign({}, req), (this.actions.currentPreloginResponse || {})), { account, password: pwd, privateKey: secCertInfo === null || secCertInfo === void 0 ? void 0 : secCertInfo.priKey }));
                }
            }
            const res = await this.login(req, retry || 1);
            const errorCode = res.msgCode || '';
            const IPERRORS = ['ERR.LOGINRULE.IPDENY', 'ERR.LOGIN.IPDENY'];
            let ipInfo = '';
            if (errorCode && IPERRORS.includes(errorCode)) {
                if (res && res.data && res.data.blockIp) {
                    ipInfo = 'IP: ' + res.data.blockIp;
                }
            }
            if (isUnLockApp) {
                const data = res.data || {};
                if (res.msgCode) {
                    data.errMsg = res.msgCode;
                }
                this.actions.preLoginPassed = false;
                if (data.location === 'exception' && errorCode === 'VERIFYCODE.REQ') {
                    return {
                        pass: false,
                        errmsg: '',
                        showVerifyCode: true,
                    };
                }
                return {
                    pass: ['secaudit', 'entry', 'mauth', 'eauth', '2fa', 'gauth', 'passchange', 'webmail', 'spamauto', 'spamapply'].includes(data.location),
                    errmsg: LoginApiImpl.getErrMsg(data.errMsg),
                };
            }
            if (res.data.location === 'crisk') {
                account && (this.actions.currentLoginRisk[account] = true);
                return {
                    pass: false,
                    riskVerify: true,
                    errmsg: '',
                    redirect: RiskPrefix + ((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.redirect),
                    originReq: res.originReq,
                };
            }
            if (isSubAccount) {
                this.fillSubAccountInfo(res, account, false, sessionName);
            }
            if (res.data) {
                res.data.noEnableBackDb = !!noEnableBackDb;
                res.data.isAutoLogin = !!isAutoLogin;
            }
            const ret = await this.processLoginResult(res);
            if ((ret === null || ret === void 0 ? void 0 : ret.pass) && !isAutoLogin) {
                await this.tryReportLoginSuccess(account);
            }
            if (!ret.pass && ret.errmsg && ipInfo) {
                ret.errmsg += ipInfo;
            }
            return ret;
        }
        catch (e) {
            if (e && typeof e === 'string' && e === 'NETWORK.ERR.TIMEOUT') {
                return {
                    pass: false,
                    timeout: true,
                    errmsg: '请求超时',
                };
            }
            return Promise.reject(e);
        }
    }
    async pushQsid(params) {
        const sessionName = params === null || params === void 0 ? void 0 : params.sessionName;
        let reqUrl = this.systemApi.getUrl('pushQsid');
        try {
            if (sessionName) {
                const sessionInfo = this.getUseSessionInfo(sessionName, sessionName);
                reqUrl = this.impl.buildUrl(reqUrl, sessionInfo);
            }
            const res = await this.impl.post(reqUrl, {});
            return res;
        }
        catch (error) {
            console.error('pushQsidError', error);
            throw new Error('获取pushQsid失败');
        }
    }
    async doMobileValidateAccountLogin(params) {
        var _a;
        const { account, password: originPwd, reg_code, reg_mobile, currentAccountNode } = params;
        const { account: account_name, domain } = this.handleAccountAndDomain(account);
        if (!account_name || !domain) {
            console.warn('input data illegal');
            return Promise.reject(ErrMsgCodeMap['ERR.LOGIN.ILLEGALINPUT']);
        }
        if (currentAccountNode && currentAccountNode !== this.storeApi.getCurrentNode()) {
            await this.doPreLogin(account);
        }
        const { pwd: password, type } = await this.getS({
            originAccount: account,
            originPwd,
            rsaEncrypt: true,
        });
        const pubid = ((_a = this.actions.currentPreloginResponse) === null || _a === void 0 ? void 0 : _a.pubid) || '';
        return this.mobileLogin({
            reg_code,
            reg_mobile,
            unq_code: this.actions.unqCode,
            domain,
            account_name,
            password,
            pubid,
            passtype: PassWordTypeMap[type],
        });
    }
    async doMobileTokenLogin(params) {
        try {
            const { account_name, domain } = params;
            const accountEmail = account_name + '@' + domain;
            if (this.systemApi.getCurrentUser()) {
                await this.doLogout(true, true);
            }
            this.loggerApi.track('login_doMobileTokenLogin_request', params);
            params.autoEntry = true;
            this.fillSecRequestInfo(params);
            const { data } = await this.impl.post(this.systemApi.getUrl('mobileTokenLogin'), Object.assign(Object.assign({}, defaultPreLoginInfo), params));
            const { code, msgCode, data: res } = data || {};
            this.loggerApi.track('login_doMobileTokenLogin_return', res);
            console.log('[login web] doMobileTokenLogin', res, code);
            if (String(code) === '500' && res) {
                if (process.env.BUILD_ISELECTRON && process.env.BUILD_ISLINGXI && res.location === 'exception' && msgCode === NO_LOGIN_RIGHTS_CODE) {
                    return {
                        errmsg: '',
                        pass: false,
                        errCode: msgCode,
                        showMailMasterDownload: true,
                    };
                }
            }
            if (String(code) === '200' && res) {
                if (res.location === 'secaudit') {
                    return {
                        pass: false,
                        showDeviceReport: true,
                    };
                }
                if (res.location === 'crisk') {
                    accountEmail && (this.actions.currentLoginRisk[accountEmail] = true);
                    return {
                        pass: false,
                        riskVerify: true,
                        errmsg: '',
                        redirect: RiskPrefix + res.redirect,
                        originReq: {
                            urlParam: defaultPreLoginInfo,
                            req: Object.assign({}, params),
                            email: res.uid,
                        },
                    };
                }
                const doorRes = await this.doMobileTokenLoginSuc({ res, accountEmail });
                if (doorRes.pass) {
                    await this.tryReportLoginSuccess(accountEmail || '');
                }
                return doorRes;
            }
            return {
                pass: false,
                errmsg: LoginApiImpl.getErrMsg(msgCode),
                errCode: msgCode,
            };
        }
        catch (e) {
            console.error('[login_impl] doMobileTokenLogin error', e, 'params', params);
            return {
                pass: false,
                errmsg: LoginApiImpl.commonCatch(e),
            };
        }
    }
    async doMobileTokenLoginSuc(params) {
        var _a;
        const { res, accountEmail } = params;
        const { refreshToken, refreshTokenExpire } = res;
        this.storeCurrentAccount({
            account: accountEmail || res.uid || '',
            refreshToken,
            refreshTokenExpire,
            mobile: (_a = this.actions.currentPreloginRequest) === null || _a === void 0 ? void 0 : _a.mobile,
        });
        console.log('[login_impl] doMobileTokenLogin', res);
        const doorRes = await this.loginDoorEnter(Object.assign(Object.assign({}, res), { pass: true, res }));
        return doorRes;
    }
    async mobileLogin(params) {
        let ret = { pass: false, errmsg: '' };
        try {
            this.loggerApi.track('login_doMobileValidateAccountLogin_mobileLoginActive', params);
            const { data } = await this.impl.post(this.systemApi.getUrl('mobileLoginActive'), Object.assign(Object.assign({}, params), defaultLoginInfo));
            const { code = '', data: res, msgCode } = data || {};
            if (String(code) === '200' && res) {
                const { token, account_name, domain } = res;
                ret = await this.doMobileTokenLogin({
                    token,
                    account_name,
                    domain,
                });
            }
            else {
                console.error('[login_impl] mobileLogin error', data);
                this.refreshStatus();
                let errmsg = LoginApiImpl.getErrMsg(msgCode);
                if (msgCode === 'ERR.SESSIONNULL') {
                    errmsg = '您长时间未操作，请您返回登录页面重新登录';
                }
                const shouldShowMailMasterDownloadTip = process.env.BUILD_ISELECTRON && process.env.BUILD_ISLINGXI && msgCode === NO_LOGIN_RIGHTS_CODE;
                if (shouldShowMailMasterDownloadTip) {
                    errmsg = '';
                }
                ret = Object.assign(Object.assign({}, ret), { errmsg, showMailMasterDownload: shouldShowMailMasterDownloadTip });
            }
        }
        catch (e) {
            console.error('[login_impl] mobileLogin error', e);
            ret = Object.assign(Object.assign({}, ret), { errmsg: LoginApiImpl.commonCatch(e) });
        }
        return ret;
    }
    async getMobileLoginToken(params) {
        try {
            const { data } = await this.impl.post(this.systemApi.getUrl('getMobileLoginToken'), Object.assign(Object.assign({}, params), defaultPreLoginInfo));
            console.log('zzzzzzzzzh getMobileLoginToken', data);
            const { code = '', data: res, msgCode } = data || {};
            if (String(code) === '200' && res) {
                return {
                    success: true,
                    data: res,
                };
            }
            return {
                success: false,
                message: LoginApiImpl.getErrMsg(msgCode),
                code: msgCode,
            };
        }
        catch (e) {
            console.error('[login_impl] getMobileLoginToken error', e);
            return {
                success: false,
                message: LoginApiImpl.commonCatch(e),
            };
        }
    }
    async doMobileCodeLogin(params) {
        const { success, message, code, data } = await this.getMobileLoginToken(params);
        console.log('[login web] getMobileLoginToken', data, success);
        if (success) {
            const { token, account_name, domain } = data;
            return this.doMobileTokenLogin({
                token,
                account_name,
                domain,
            });
        }
        return {
            pass: false,
            errmsg: message,
            errCode: code,
        };
    }
    async doMobileBindAccountLogin(params) {
        await this.doPreLogin(this.accountApi.doGetAccount({
            accountName: params.account_name,
            domain: params.domain,
        }));
        const { success, message, data } = await this.getMobileLoginToken(Object.assign(Object.assign({}, params), { type: 1 }));
        if (success) {
            const { token, account_name, domain } = data;
            return this.doMobileTokenLogin({
                token,
                account_name,
                domain,
            });
        }
        return {
            pass: false,
            errmsg: message,
        };
    }
    async doUpdateRefreshToken(params) {
        this.loggerApi.track('login_checkRefreshToken_request', params);
        const { data } = await this.impl.post(this.systemApi.getUrl('refreshToken'), Object.assign(Object.assign({}, defaultPreLoginInfo), params));
        const { code, msgCode, data: res } = data || {};
        this.loggerApi.track('login_checkRefreshToken_return', {
            code,
            msgCode,
            res,
        });
        if (String(code) === '200' && res) {
            const { token, expire } = res;
            await this.accountApi.doUpdateAccountList([
                {
                    id: this.accountApi.doGetAccount({
                        accountName: params.account_name,
                        domain: params.domain,
                    }),
                    refreshToken: token,
                    refreshTokenExpire: expire,
                },
            ]);
            return {
                success: true,
                data: Object.assign(Object.assign({}, params), { token }),
            };
        }
        return {
            success: false,
            message: LoginApiImpl.getErrMsg(msgCode),
        };
    }
    async doRefreshTokenLogin(params) {
        var _a, _b;
        try {
            const { isSubAccount, noEnableBackDb, isAutoLogin = false, isMemorySession = false } = params;
            const email = this.accountApi.doGetAccount({
                accountName: params.account_name,
                domain: params.domain,
            });
            const sessionName = isMemorySession ? `memory-${new Date().getTime().toString()}` : isSubAccount ? this.systemApi.getSessionNameOfSubAccount(email) : '';
            await this.doPreLogin(email, isSubAccount, sessionName);
            this.loggerApi.track('login_refreshTokenLogin_request', params);
            const currentNode = !isSubAccount ? undefined : this.actions.subAccountNodeMap[email] || defauleNode;
            let url = this.systemApi.getUrl('refreshTokenLogin', currentNode);
            if (process.env.BUILD_ISELECTRON && sessionName) {
                const sessionInfo = this.getUseSessionInfo(isMemorySession ? '' : sessionName, sessionName);
                url = this.impl.buildUrl(url, sessionInfo);
            }
            const req = Object.assign(Object.assign({}, defaultPreLoginInfo), params);
            req.autoEntry = true;
            this.fillSecRequestInfo(req);
            if (process.env.BUILD_ISWEB && isSubAccount) {
                this.fillAutoEntryAndNoCookieInfo(req);
            }
            const { data } = await this.impl.post(url, req);
            const { code, msgCode, data: res } = data || {};
            this.loggerApi.track('login_refreshTokenLogin_return', data);
            if (String(code) === '200' && res) {
                if (isMemorySession) {
                    return {
                        pass: true,
                    };
                }
                const { refreshToken, refreshTokenExpire, mobile } = res;
                const { account_name, domain } = params;
                const curAccount = account_name + '@' + domain;
                if (!isSubAccount) {
                    this.actions.currentWillLoginAccount = curAccount;
                }
                else {
                    this.actions.currentWillLoginSubAccount = curAccount;
                }
                this.storeCurrentAccount({
                    account: curAccount,
                    refreshToken,
                    refreshTokenExpire,
                    mobile: mobile || ((_a = this.actions.currentPreloginRequest) === null || _a === void 0 ? void 0 : _a.mobile),
                    isSubAccount,
                    email,
                });
                const currentUser = this.systemApi.getCurrentUser();
                let isSharedAccountSwitch = false;
                let originAccount;
                if (currentUser && currentUser.isSharedAccount) {
                    isSharedAccountSwitch = true;
                    originAccount = ((_b = currentUser.originAccount) === null || _b === void 0 ? void 0 : _b.email) || '';
                }
                console.log('[login_impl] doRefreshTokenLogin', res);
                if (isSubAccount) {
                    if (!res.data) {
                        res.data = {};
                    }
                    res.isSubAccount = isSubAccount;
                    res.agentEmail = email;
                    this.fillSubAccountInfo(res, email, false, sessionName);
                }
                const doorParam = Object.assign(Object.assign({}, res), { pass: true, res: Object.assign(Object.assign({ originAccount, noEnableBackDb, isAutoLogin, isSharedAccountSwitch }, res), (isSubAccount ? res.data || {} : {})) });
                return this.loginDoorEnter(doorParam);
            }
            return {
                pass: false,
                shouldLogout: msgCode === SEC_DEVICE_LOGOUT_CODE,
                errmsg: LoginApiImpl.getErrMsg(msgCode),
            };
        }
        catch (e) {
            console.error('[login_impl] doRefreshTokenLogin error', e, 'params', params);
            if (e && typeof e === 'string' && e === 'NETWORK.ERR.TIMEOUT') {
                this.loggerApi.track('login_refreshTokenLogin_request_timeout', {
                    params,
                });
                return {
                    pass: false,
                    timeout: true,
                    errmsg: '请求超时',
                };
            }
            const errmsg = LoginApiImpl.commonCatch(e);
            this.loggerApi.track('login_refreshTokenLogin_request_failed', {
                params,
                error: errmsg,
            });
            return {
                pass: false,
                errmsg,
            };
        }
    }
    storePwd(pwd, pwdType = 1, isSubAccount, email) {
        let password = pwd;
        if (pwdType !== 2) {
            if (this.testPwdStyleIsNew(password)) {
                const newPwd = password.replace(this.encryptedPwdHead, '').replace(this.encryptedPwdTail, '');
                password = this.systemApi.decryptByKey(newPwd, this.storeApi.getUUID());
            }
            password = this.systemApi.md5(pwd);
        }
        this.storeCurrentAccount({
            pwd: password,
            isSubAccount,
            email,
        });
    }
    storeCurrentAccount(params) {
        const isSubAccount = !!params.isSubAccount;
        const email = params.email || '';
        if (isSubAccount && email) {
            if (!this.actions.currentSubAccount[email]) {
                this.actions.currentSubAccount[email] = {};
            }
        }
        const { a, k, tExpire, t, mobile: m, lastLogin = Date.now() } = (!isSubAccount ? this.actions.currentAccount : this.actions.currentSubAccount[email]) || {};
        const { account = a, refreshToken = t, mobile = m, refreshTokenExpire = tExpire, pwd = k } = params;
        const newInfo = {
            a: account || '',
            t: refreshToken,
            k: pwd,
            mobile,
            tExpire: refreshTokenExpire,
            lastLogin,
        };
        if (!isSubAccount) {
            this.actions.currentAccount = newInfo;
        }
        else {
            this.actions.currentSubAccount[email] = newInfo;
        }
    }
    storeCurrentSubAccount(params) {
        const subAccountEmail = (params && params.account) || '';
        if (!subAccountEmail) {
            return;
        }
        if (!this.actions.currentSubAccount) {
            this.actions.currentSubAccount = {};
        }
        const { a, k, tExpire, t, mobile: m, lastLogin = Date.now() } = this.actions.currentSubAccount[subAccountEmail] || {};
        const { account = a, refreshToken = t, mobile = m, refreshTokenExpire = tExpire, pwd = k } = params;
        this.actions.currentSubAccount[subAccountEmail] = {
            a: account || '',
            t: refreshToken,
            k: pwd,
            mobile,
            tExpire: refreshTokenExpire,
            lastLogin,
        };
    }
    fillSecRequestInfo(req) {
        if (process.env.BUILD_ISELECTRON && process.env.BUILD_ISLINGXI) {
            const extraInfo = this.getSecLoginInfo();
            Object.assign(req || {}, Object.assign(Object.assign({}, extraInfo), { secBelongScope: undefined }));
        }
    }
    async login(req, retry) {
        retry = retry === undefined ? 2 : retry;
        try {
            const hash = decodeURIComponent(window.location.hash);
            const matchArr = hash.match(this.changeHashUrl);
            const len = (matchArr === null || matchArr === void 0 ? void 0 : matchArr.length) || 0;
            const _from = len > 1 ? matchArr[1] : 'login';
            let urlParam = { _from };
            if (debugSecCert) {
                urlParam.p = 'sirius';
            }
            if ((req.sessionName && req.sessionName.length) || (req.setSessionName && req.setSessionName.length)) {
                const sessionInfo = this.getUseSessionInfo(req.sessionName || '', req.setSessionName || req.sessionName || '');
                urlParam = Object.assign(urlParam, sessionInfo);
            }
            const isSubAccount = !!req.isSubAccount;
            req.autoEntry = true;
            if (isSubAccount && process.env.BUILD_ISWEB) {
                this.fillAutoEntryAndNoCookieInfo(req);
            }
            if (isSubAccount) {
                req.siriusLoginType = 'subAccountBindLogin';
            }
            const email = isSubAccount ? `${req.account_name}@${req.domain}` : undefined;
            const response = await this.impl.post(this.impl.buildUrl(this.getUrl('login', email), urlParam), req);
            const data = this.unpackLoginData(response);
            return Object.assign(Object.assign({}, data), { originReq: {
                    urlParam,
                    req,
                    email,
                } });
        }
        catch (error) {
            if (error && typeof error === 'string' && error === 'NETWORK.ERR.TIMEOUT') {
                if (retry > 0) {
                    await wait(1500 * (3 - retry) + 500);
                    return this.login(req, retry - 1);
                }
            }
            return Promise.reject(error);
        }
    }
    async doOpenAdvertUrl(url, width, height) {
        const deviceInfo = await this.systemApi.getDeviceInfo();
        const currentUser = this.systemApi.getCurrentUser();
        let domain = '';
        let account_name = '';
        let refreshToken = '';
        if (currentUser) {
            const email = currentUser.loginAccount || currentUser.id || '';
            refreshToken = currentUser.refreshToken || '';
            if (email) {
                const info = this.handleAccountAndDomain(email);
                domain = info.domain;
                account_name = info.account;
            }
        }
        const openUrl = this.impl.buildUrl(url, Object.assign(Object.assign({}, deviceInfo), { refreshToken, account_name, domain }));
        if (process.env.BUILD_ISELECTRON) {
            const wins = await window.electronLib.windowManage.getAllWinInfo();
            if (wins && wins.length > 0) {
                const win = wins.find(w => w.type === 'customer' && w.url === openUrl);
                if (win) {
                    window.electronLib.windowManage.show(win.id);
                    return;
                }
            }
            this.systemApi.createWindow({ type: 'customer', url: openUrl, bounds: width && height ? { width, height, x: 50, y: 50 } : undefined });
        }
        else {
            window.open(openUrl, '_blank');
        }
    }
    async csplLogin(originReq) {
        try {
            const { urlParam, req, email, subAccountMsg } = originReq;
            const response = await this.impl.post(this.impl.buildUrl(this.getUrl('csplLogin', email), urlParam), req);
            const data = this.unpackLoginData(response);
            if (subAccountMsg) {
                this.fillSubAccountInfo(data, subAccountMsg.account, false, subAccountMsg.sessionName);
            }
            const ret = await this.processLoginResult(data);
            return ret;
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    static processLogin(data) {
        const content = data.data || {};
        if (data.msgCode) {
            content.errCode = data.msgCode;
        }
        if (data.msgCodeDesc) {
            content.errMsg = data.msgCodeDesc || data.error_msg;
        }
        return content;
    }
    parseCookie(cookieString) {
        const cookieObj = {};
        if (cookieString) {
            const cookieArray = cookieString.split(';');
            cookieArray.forEach(cookie => {
                const [key, value] = cookie.split('=');
                cookieObj[key.trim()] = value.trim();
            });
        }
        return cookieObj;
    }
    loginDoorEnter(res) {
        if (res.pass) {
            const { nickname, uid, sid, coremail, orgName, cookieName, isSharedAccountSwitch, noEnableBackDb, sessionName, isSubAccount, isThirdAccount, agentEmail, token, sess, node, isAutoLogin, secCertInfo, } = res.res;
            if (agentEmail) {
                let cooikeInfo = this.actions.bindSubAccountCookieMapInfo[agentEmail];
                if (!cooikeInfo) {
                    cooikeInfo = this.actions.bindSubAccountCookieMapInfo[agentEmail] = {};
                }
                const uidStr = uid || '';
                cooikeInfo.qiye_uid = uidStr;
                cooikeInfo['qiye-uid'] = uidStr;
                const qiyeTokenStr = token || '';
                cooikeInfo.qiye_token = qiyeTokenStr;
                cooikeInfo['qiye-token'] = qiyeTokenStr;
                cooikeInfo.coremail = coremail || '';
                cooikeInfo['qiye-sess'] = sess || '';
                if (uid) {
                    this.actions.bindSubAccountCookieMapInfo[uid] = cooikeInfo;
                }
            }
            return this.loginSucceed({
                noEnableBackDb,
                isSharedAccountSwitch,
                uid: uid,
                nickname,
                cookieName: sid,
                orgName,
                cnName: cookieName,
                sessionName,
                isSubAccount,
                isThirdAccount,
                agentEmail,
                isAutoLogin,
                secCertInfo,
                node: isSubAccount ? node : '',
            })
                .then(_ => {
                res.uid = uid;
                return res;
            })
                .catch(err => {
                console.error(err);
                return {
                    pass: false,
                    errmsg: err && err.message ? err.message : '登录错误',
                };
            });
        }
        return res;
    }
    loginDoorEnterMobile(res) {
        var _a;
        if (res.pass) {
            const { nickname, uid, sid, coremail, orgName, cookieName, isSharedAccountSwitch, noEnableBackDb, sessionName, isSubAccount, isThirdAccount, agentEmail, token, sess, node, isAutoLogin, } = res.res;
            const _email = agentEmail || uid;
            let cooikeInfo = this.actions.bindSubAccountCookieMapInfo[_email];
            if (!cooikeInfo) {
                cooikeInfo = this.actions.bindSubAccountCookieMapInfo[_email] = {};
            }
            const uidStr = uid || '';
            cooikeInfo.qiye_uid = uidStr;
            cooikeInfo['qiye-uid'] = uidStr;
            const qiyeTokenStr = token || '';
            cooikeInfo.qiye_token = qiyeTokenStr;
            cooikeInfo['qiye-token'] = qiyeTokenStr;
            cooikeInfo.coremail = coremail || '';
            cooikeInfo['qiye-sess'] = sid || '';
            const cookieObj = this.parseCookie(document.cookie);
            const cookieCoremail = cookieObj.Coremail || '';
            const userInfo = {
                uid: uidStr,
                id: uidStr,
                email: uidStr,
                qiyeToken: qiyeTokenStr,
                domain: (uid === null || uid === void 0 ? void 0 : uid.split('@')[1]) || '',
                coremail: cookieCoremail,
                sessionId: sid,
                node: 'hz',
            };
            if (_email) {
                if (!this.systemApi.getCurrentUser() || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) === uidStr) {
                    this.storeApi.setLastAccount(userInfo);
                }
                else {
                    this.storeApi.setLastAccount(userInfo, userInfo === null || userInfo === void 0 ? void 0 : userInfo.id);
                }
            }
        }
        return res;
    }
    requestDoorApi(res) {
        const { nickname, uid, orgName, cookieName, isSharedAccountSwitch, originAccount, noEnableBackDb, sessionName, isSubAccount, isThirdAccount, agentEmail } = res.res;
        const req = defaultLoginDoor;
        const uid1 = uid || '';
        res.uid = uid;
        req.uid = uid1;
        if (isSharedAccountSwitch) {
            if (originAccount) {
                req.origin = originAccount;
            }
            else {
                const currentUser = this.systemApi.getCurrentUser();
                if (currentUser) {
                    req.origin = currentUser.id;
                }
            }
        }
        const urlKey = 'loginDoor';
        let url;
        if (sessionName && sessionName.length) {
            const sessionInfo = this.getUseSessionInfo(sessionName, sessionName);
            url = this.impl.buildUrl(this.getUrl(urlKey, agentEmail), sessionInfo);
        }
        else {
            url = this.getUrl(urlKey);
        }
        return this.impl
            .get(url, req, noHeaderTokenConfig)
            .then(this.unpackLoginData.bind(this))
            .then(async (r) => {
            if (String(r.code) === '200') {
                const { sid } = r.data;
                await this.loginSucceed({
                    noEnableBackDb,
                    isSharedAccountSwitch,
                    uid: uid1,
                    nickname,
                    cookieName: sid,
                    orgName,
                    cnName: cookieName,
                    sessionName,
                    isSubAccount,
                    isThirdAccount,
                    agentEmail,
                });
                return res;
            }
            return {
                errmsg: LoginApiImpl.getErrMsg(r.msgCode),
                pass: false,
            };
        })
            .catch(reason => {
            console.log('[login] door api error', reason);
            return {
                errmsg: LoginApiImpl.commonCatch(reason),
                pass: false,
            };
        });
    }
    handleLoginResponse(res) {
        this.loggerApi.track('login_network_return', res);
        console.log('[login] login_network_return:' + JSON.stringify(res));
        const { pass, location, errMsg, errCode, mobile, eauthEmail, uid, refreshToken, refreshTokenExpire, isSharedAccountSwitch, noEnableBackDb, isSubAccount, isThirdAccount, agentEmail, sessionName, isAutoLogin, redirect, } = res;
        if (!isSubAccount && uid && this.actions.currentPreloginRequest) {
            const accounts = this.systemApi.handleAccountAndDomain(uid);
            this.actions.currentPreloginRequest.account_name = accounts.account;
            this.actions.currentPreloginRequest.domain = accounts.domain;
        }
        if (location === 'webmail' && pass) {
            const accountInfo = {
                account: uid,
                refreshToken,
                refreshTokenExpire,
            };
            if (!isSubAccount) {
                this.storeCurrentAccount(accountInfo);
            }
            else {
                this.storeCurrentSubAccount(accountInfo);
            }
            return {
                errmsg: errCode || '',
                pass: true,
                res,
                isSharedAccountSwitch,
                noEnableBackDb,
                isSubAccount,
                isThirdAccount,
                agentEmail,
                sessionName,
                isAutoLogin,
            };
        }
        if (!isSubAccount && this.actions.loginMethod === 'code') {
            this.actions.codeRetryTime += 1;
        }
        this.dataTrackApi.track('login_not_pass_occurred', { location });
        if (location === 'custcert2fa') {
            return {
                errmsg: '',
                secondCheck: true,
                checkType: 'cert',
                mobile,
                showConfig: false,
                pass: false,
                res,
            };
        }
        if (location === 'mauth') {
            return {
                errmsg: '',
                secondCheck: true,
                checkType: 'mobile',
                mobile,
                showConfig: false,
                pass: false,
                res,
            };
        }
        if (location === 'eauth') {
            return {
                errmsg: '',
                secondCheck: true,
                checkType: 'mail',
                eauthEmail,
                showConfig: false,
                pass: false,
                res,
            };
        }
        if (location === 'spamauto' || location === 'spamapply') {
            const typeMap = {
                spamauto: 'auto',
                spamapply: 'apply',
            };
            return {
                errmsg: '',
                secondCheck: false,
                pass: false,
                mobile,
                spamLock: true,
                spamType: typeMap[location],
                res,
            };
        }
        if (location === '2fa') {
            return {
                errmsg: '',
                secondCheck: true,
                showConfig: true,
                pass: false,
                res,
            };
        }
        if (location === 'gauth') {
            return {
                errmsg: '暂不支持将军令登录',
                pass: false,
                res,
            };
        }
        if (location === 'passchange') {
            return {
                errmsg: '',
                showResetPass: true,
                pass: false,
                res,
            };
        }
        if (location === 'exception' && errCode === 'VERIFYCODE.REQ') {
            return {
                errmsg: '',
                pass: false,
                res,
                showVerifyCode: true,
            };
        }
        if (process.env.BUILD_ISELECTRON && process.env.BUILD_ISLINGXI && location === 'exception' && errCode === NO_LOGIN_RIGHTS_CODE) {
            return {
                errmsg: '',
                pass: false,
                errCode,
                showMailMasterDownload: true,
            };
        }
        if (location === 'secaudit') {
            return {
                errmsg: '当前设备已禁止登录，可联系管理员添加权限',
                pass: false,
                res,
                showDeviceReport: true,
            };
        }
        if (location === 'euprivacy') {
            return {
                pass: false,
                shouldRedirect: true,
                redirectUrl: `${window.location.protocol}//${window.location.host}${redirect}`,
            };
        }
        let errmsg = errMsg;
        if (errCode && errCode in ErrMsgCodeMap) {
            errmsg = LoginApiImpl.getErrMsg(errCode);
        }
        return {
            errmsg,
            pass: false,
            errCode,
            res,
        };
    }
    getIsAddAccountPage() {
        return this.systemApi.getIsAddAccountPage() || this.systemApi.getIsAddSubAccountPage() || this.systemApi.getIsAddPersonalSubAccountPage();
    }
    addSubAccountsToDataStore(emailInfo) {
        this.storeApi.addSubAccountToList(emailInfo);
    }
    getSessionNameOfSubAccount(subAccount, mainAccount) {
        return `persist:${mainAccount}-${subAccount}`;
    }
    async loginSucceed(data) {
        const { uid, isSharedAccountSwitch = false, isCorpMail = false, noEnableBackDb = false, isSubAccount = false, sessionName = '', agentEmail = '', isAutoLogin, secCertInfo, } = data;
        if (!isSubAccount) {
            this.impl.setLogoutStatus(false);
        }
        else {
            this.impl.setSubAccountLogoutStatus(uid, false);
        }
        const storeCurrentUser = await this.getAccountStored(uid, isSubAccount);
        const cookies = await this.setLoginSucceedCookie(sessionName, isSubAccount, uid || agentEmail);
        const user = this.setLoginSucceedUser({ storeCurrentUser, data, cookies });
        if (process.env.BUILD_ISELECTRON && isSubAccount && sessionName && cookies && cookies.length) {
            const subAccountSessionName = this.getSessionNameOfSubAccount(uid, user.mainAccount || '');
            try {
                await window.electronLib.appManage.clearCookieStore(subAccountSessionName);
            }
            catch (ex) {
                console.error('clearCookieStore-ex', ex);
            }
            await window.electronLib.appManage.setCookieStore(cookies, subAccountSessionName);
        }
        if (isSubAccount) {
            this.addSubAccountsToDataStore({ email: uid, agentEmail: user.agentEmail || uid });
            if (user.node) {
                this.setupNodeInfo(user.node, true, uid);
            }
        }
        await this.storeApi.setLastAccount(user, isSubAccount ? uid : '');
        console.log('[login] login account stored ', user);
        if (!isSubAccount) {
            await this.sendLoginEvent(user, false, isAutoLogin).catch(err => {
                this.loggerApi.track('login_sendLoginEvent_error', err);
            });
        }
        if (!isSubAccount) {
            await this.productAuthApi.saveAuthConfigFromNet();
        }
        this.setLoginSucceedAccountStatus(isSubAccount ? uid : '');
        if (!isSubAccount) {
            this.eventApi.sendSysEvent({
                eventName: 'initModule',
                eventStrData: 'account',
            });
        }
        await this.handleLoginSucceedBgAccount({ isSharedAccountSwitch, user, noEnableBackDb });
        if (secCertInfo) {
            await this.accountApi.doSaveSecCertInfo(uid, secCertInfo);
        }
        if (!isCorpMail) {
            this.bindAccountDevice()
                .then()
                .catch(ex => {
                console.warn('[login] bind account ', ex);
            });
        }
        this.mailConfApi.loadConfFromServer(uid);
        this.systemApi.getActiveUserTrackParams(isSharedAccountSwitch).then(params => {
            this.dataTrackApi.track('pc_dailyActiveUser', Object.assign({ type: 'loginResult' }, (params || {})));
        });
    }
    async reportEdmLogin() {
        setTimeout(() => {
            this.storeApi.get(LoginApiImpl.edmLoginReportKey).then(rs => {
                if (!rs.suc || !rs.data || +rs.data <= LoginApiImpl.edmLoginReportMax) {
                    const reportCount = rs.data !== undefined && +rs.data ? +rs.data : 0;
                    const url = this.systemApi.getUrl('edmLoginReport');
                    this.impl
                        .post(url)
                        .then((res) => {
                        const resData = res.data;
                        if ((resData === null || resData === void 0 ? void 0 : resData.code) === 0) {
                            this.storeApi.put(LoginApiImpl.edmLoginReportKey, String(reportCount + 1));
                        }
                        else {
                            console.error('edm login report error code !== 0');
                        }
                    })
                        .catch(e => {
                        console.error('edm login report error', e);
                    });
                }
            });
        }, 5000);
    }
    setOriginAccount(params) {
        const { isSharedAccountSwitch, originAccountEmail } = params;
        const currentUser = this.systemApi.getCurrentUser();
        let originAccount;
        if (isSharedAccountSwitch && originAccountEmail) {
            if (!currentUser || currentUser.id === originAccountEmail) {
                const emailInfo = this.handleAccountAndDomain(originAccountEmail);
                originAccount = {
                    email: originAccountEmail,
                    nickName: emailInfo.account,
                    avatar: '',
                };
            }
            else {
                originAccount = {
                    email: originAccountEmail,
                    nickName: currentUser === null || currentUser === void 0 ? void 0 : currentUser.nickName,
                    avatar: currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatar,
                };
            }
        }
        else if (isSharedAccountSwitch && currentUser) {
            if (!currentUser.originAccount) {
                originAccount = { email: currentUser.id || '', nickName: currentUser.nickName || '', avatar: currentUser.avatar || '' };
            }
            else {
                originAccount = currentUser.originAccount;
            }
        }
        return originAccount;
    }
    setLoginSucceedUser(params) {
        const { data, storeCurrentUser, cookies } = params;
        const { uid, nickname = '', cookieName = '', orgName = '', cnName, accessToken = '', accessSecret = '', isCorpMail = false, nonce = '', mobile = '', isSharedAccountSwitch = false, originAccountEmail = '', isSubAccount = false, isThirdAccount = false, agentEmail = '', node = '', } = data;
        const accountMd5 = this.systemApi.md5(uid || '__', true);
        const { mobile: m, t, tExpire, a, } = ((isSubAccount ? (!this.actions.currentSubAccount ? {} : this.actions.currentSubAccount[uid]) : this.actions.currentAccount) || {});
        const originAccount = this.setOriginAccount({ isSharedAccountSwitch, originAccountEmail });
        const { account: accountName, domain } = uid ? this.handleAccountAndDomain(uid) : {};
        const currentUser = isSubAccount ? this.systemApi.getCurrentUser() : undefined;
        const mainAccountEmail = currentUser && currentUser.id ? currentUser.id : '';
        const user = {
            nickName: nickname,
            avatar: (storeCurrentUser === null || storeCurrentUser === void 0 ? void 0 : storeCurrentUser.avatar) || '',
            contact: storeCurrentUser === null || storeCurrentUser === void 0 ? void 0 : storeCurrentUser.contact,
            lastLoginTime: Date.now(),
            sessionId: cookieName,
            id: uid,
            loginAccount: isSubAccount ? agentEmail : this.actions.currentWillLoginAccount,
            domain,
            accountName,
            accountMd5,
            cookies,
            node: node || (isSubAccount && !isThirdAccount ? this.actions.subAccountNodeMap[agentEmail] || this.actions.currentNode : this.actions.currentNode),
            mobile: isCorpMail ? mobile : m,
            refreshToken: t,
            refreshTokenExpire: tExpire,
            company: orgName,
            isSharedAccount: isSharedAccountSwitch,
            originAccount,
            cnName,
            prop: {
                company: orgName,
                mailMode: isCorpMail ? loginUtils.getCorpMailModeVal() : loginUtils.getHMailModeVal(),
                accessToken,
                accessSecret,
                nonce,
            },
            isSubAccount,
            isThirdAccount,
            agentEmail: isSubAccount && !isThirdAccount ? uid : agentEmail,
            mainAccount: mainAccountEmail,
            mainAccountEmail,
        };
        if (a !== user.id) {
            user.bmId = a;
        }
        return user;
    }
    async setLoginSucceedCookie(sessionNameParam, isSubAccount, agentEmail) {
        let cookies;
        const asyncCookie = async (retry) => {
            if (process.env.BUILD_ISELECTRON) {
                try {
                    const isAddAccountPage = this.getIsAddAccountPage();
                    const isBkLoginPage = this.systemApi.isBkLoginInit();
                    if (isAddAccountPage || isBkLoginPage || (sessionNameParam && sessionNameParam.length)) {
                        const sessionName = sessionNameParam || this.systemApi.getCurrentSessionName();
                        if (sessionName && sessionName.length) {
                            cookies = await window.electronLib.appManage.getSessionCookieStore({
                                sessionName,
                            });
                        }
                    }
                    else {
                        cookies = await window.electronLib.appManage.getCookieStore();
                    }
                }
                catch (e) {
                    console.warn(e);
                    if (retry > 0) {
                        await asyncCookie(retry - 1);
                    }
                }
            }
            if (process.env.BUILD_ISWEB && isSubAccount && agentEmail) {
                cookies = [];
                const cookieInfo = this.actions.bindSubAccountCookieMapInfo[agentEmail];
                if (cookieInfo) {
                    return Object.keys(cookieInfo).forEach(currKey => {
                        cookies.push({
                            name: currKey,
                            value: cookieInfo[currKey],
                            sameSite: 'no_restriction',
                        });
                    });
                }
            }
        };
        await asyncCookie(2);
        return cookies;
    }
    setLoginSucceedAccountStatus(emailParam) {
        if (!emailParam) {
            this.actions.logout = false;
            this.noLoginStatus = false;
            this.logoutProcessing = false;
        }
        else {
            this.actions.subAccountLogoutMap[emailParam] = false;
            this.subAccountNoLoginStatusMap[emailParam] = false;
            this.subAccountLogoutProcessingMap[emailParam] = false;
        }
    }
    async handleLoginSucceedBgAccount(params) {
        var _a, _b;
        const { user, isSharedAccountSwitch, noEnableBackDb } = params;
        const isBkLoginPage = this.systemApi.isBkLoginInit();
        const isAddAccountPage = this.getIsAddAccountPage();
        if (user.isSubAccount) {
            user.mainAccount = user.mainAccountEmail;
        }
        const isSubAccount = !!user.isSubAccount;
        const isMainAccount = !isAddAccountPage && !isSubAccount && !isBkLoginPage;
        if (!noEnableBackDb && isMainAccount && process.env.BUILD_ISELECTRON) {
            await window.electronLib.storeManage.set('app', 'initAccount', 'true');
            await this.createBKStableWindow();
            this.enableBackgroundDB();
        }
        if (!isSharedAccountSwitch) {
            const _user = Object.assign(Object.assign({}, user), { expired: false, pwd: isSubAccount ? '' : (_a = this.actions.currentAccount) === null || _a === void 0 ? void 0 : _a.k });
            await this.accountApi.doSaveCurrentAccount(_user);
        }
        if (!noEnableBackDb && isMainAccount && !this.systemApi.isElectron() && ((_b = window === null || window === void 0 ? void 0 : window.bridgeApi) === null || _b === void 0 ? void 0 : _b.master)) {
            this.enableBackgroundDB();
            window.bridgeApi.master.createSubPageInWeb();
        }
        if (isSubAccount && !isAddAccountPage) {
            this.eventApi.sendSysEvent({
                eventName: 'subAccountDBChanged',
            });
        }
    }
    async createBKStableWindow(force) {
        if (!force) {
            const isLowMemoryMode = this.systemApi.getIsLowMemoryModeSync();
            if (isLowMemoryMode) {
                return Promise.resolve();
            }
        }
        return window.electronLib.windowManage
            .createWindow({ type: 'bkStable', manualShow: true })
            .then(res => {
            console.log('!!! -- build app init window success -- !!!');
            return res;
        })
            .catch(err => {
            this.loggerApi.track('login_createBKStableWindow_error', err);
        });
    }
    async sendLoginEvent(user, timeout, isAutoLogin) {
        const isAddAccountPage = this.getIsAddAccountPage();
        if (isAddAccountPage || this.systemApi.isBkLoginInit() || this.noLoginEvent) {
            return Promise.resolve('');
        }
        const event = {
            eventName: isAutoLogin ? 'autoLogin' : 'login',
            eventData: user,
            eventSeq: 0,
            eventStrData: timeout ? 'timeout_event' : 'event',
        };
        try {
            const sendSysEvent = this.eventApi.sendSysEvent(event) || Promise.resolve('');
            const ret = await sendSysEvent;
            return ret;
        }
        catch (e) {
            return '';
        }
    }
    async getSeCertSign(params) {
        const { privateKey = '', rand = '', account = '', password, secCertTime, secCertSn, secName, secOsType, secMdc = '' } = params;
        const content = account + password + rand + secCertTime + secCertSn + secName + secOsType + secMdc;
        return this.systemApi.RSAEncryptData(privateKey, content);
    }
    async getS(params) {
        const { originPwd, originAccount, rsaEncrypt, md5Encrypt, isSubAccount, email } = params;
        if (!originAccount) {
            throw new Error('无法找到账户信息');
        }
        if (originPwd === LoginApiImpl.accountPwdAutoFilled) {
            const storedAccount = !isSubAccount ? await this.getAccountStored(originAccount) : await this.getAccountStored(originAccount, isSubAccount);
            const pwd = storedAccount === null || storedAccount === void 0 ? void 0 : storedAccount.pwd;
            if (!pwd) {
                throw new Error('无法获取用户密码');
            }
            console.log('[login] got password for ' + account, pwd);
            return { pwd, type: 'md5' };
        }
        let decryptPwd = originPwd;
        if (this.testPwdStyleIsNew(originPwd)) {
            const newPwd = originPwd.replace(this.encryptedPwdHead, '').replace(this.encryptedPwdTail, '');
            decryptPwd = this.systemApi.decryptByKey(newPwd, this.storeApi.getUUID());
            if (environment === 'dev' || environment === 'test' || environment === 'local') {
                console.log('[login] got real pwd ' + decryptPwd);
            }
        }
        if (rsaEncrypt) {
            const emailRsaInfo = (!isSubAccount ? this.actions.currentPreloginResponse : this.actions.currentSubAccountPreLoginResponse[email || '']) || {};
            const m = emailRsaInfo.modulus || '';
            const e = emailRsaInfo.exponent || '';
            const rand = emailRsaInfo.rand || '';
            return {
                pwd: this.systemApi.rsaEncrypt(m, e, rand, decryptPwd),
                type: 'rsa',
            };
        }
        if (md5Encrypt) {
            return { pwd: this.systemApi.md5(decryptPwd, false), type: 'md5' };
        }
        return { pwd: decryptPwd, type: 'plain' };
    }
    testPwdStyleIsNew(pwd) {
        return pwd ? pwd.startsWith(this.encryptedPwdHead) && pwd.endsWith(this.encryptedPwdTail) : undefined;
    }
    doOpenForgetPwdUrl(isCorpMail, email) {
        let url = externalJumpUrls.forgetPwd;
        if (isCorpMail && email) {
            const dna = this.handleAccountAndDomain(email);
            const isNeteaseDoamin = corpLoginUtils.getIsNeteaseDomain(dna.domain);
            if (isNeteaseDoamin) {
                url = corpLoginUtils.CONSTANTS.NETEASE_RESET_PWD_URL;
            }
        }
        const webMailHParam = this.systemApi.getWebMailLangStr();
        const urlWithLang = url && url.indexOf('?') ? url.replace('?', `?hl=${webMailHParam}&`) : url;
        this.systemApi.openNewWindow(urlWithLang);
        return '';
    }
    doOpenPromptPage() {
        this.systemApi.openNewWindow(externalJumpUrls.prompt);
        return '';
    }
    doOpenMailMasterDownloadPage() {
        if (process.env.BUILD_ISELECTRON) {
            this.systemApi.openNewWindow('https://dashi.163.com/index.html');
        }
    }
    async doLoadDataAndAutoLogin(loginInfoKey) {
        if (this.systemApi.getCurrentUser()) {
            await this.doLogout(true, false);
        }
        return this.storeApi
            .get(loginInfoKey, { prefix: 'lg-', noneUserRelated: true })
            .then(rs => {
            if (rs && rs.suc && rs.data) {
                const content = this.systemApi.decryptByKey(rs.data, loginInfoKey);
                const data = JSON.parse(content);
                return data;
            }
            return undefined;
        })
            .then(rs => {
            if (rs) {
                return rs;
            }
            const url = this.systemApi.getUrl('getData');
            return this.impl.get(url).then((res) => {
                if (res.data && res.data.success) {
                    const dt = res.data.data;
                    if (dt) {
                        const content = this.systemApi.decryptByKey(dt, loginInfoKey);
                        const data = JSON.parse(content);
                        return data;
                    }
                }
                return Promise.reject(new Error('未取得必要登录数据'));
            });
        })
            .then(({ account_name, password }) => this.doLogin({
            account: account_name,
            pwd: password,
        }));
    }
    doOpenConfigPage() {
        this.systemApi.openNewWindow(externalJumpUrls.bindNewPwd);
        return '';
    }
    getIsLingxiWeb() {
        if (!inWindow())
            return false;
        if (window && window.electronLib)
            return false;
        const isWebMail = profile && profile.startsWith('webmail');
        if (isWebMail)
            return false;
        return true;
    }
    sendVerifyCode(req, sessionName) {
        const isLingXiWeb = this.getIsLingxiWeb();
        if (isLingXiWeb) {
            req.p = 'sirius';
        }
        let isSubAccount = false;
        if (sessionName) {
            isSubAccount = true;
            const sessionInfo = this.getUseSessionInfo(sessionName, sessionName);
            req = Object.assign(req, sessionInfo);
            req.sendCodeType = 0;
        }
        const url = this.impl.buildUrl(this.getUrl('sendCode', isSubAccount ? req.account : undefined), Object.assign(Object.assign({}, req), { type: req.sendCodeType }));
        return this.impl
            .get(url, {}, {})
            .then(this.unpackLoginData.bind(this))
            .then(({ code, msgCode }) => {
            if (String(code) === '200') {
                return '';
            }
            return msgCode === 'ERR.LOGIN.MLOGINSMSREQ' && req.sendCodeType === 2
                ? '今日此手机验证码获取次数已达到10次上限'
                : LoginApiImpl.getErrMsg(msgCode) || '发送失败，请重试';
        })
            .catch(reason => {
            console.warn(reason);
            return '发送失败，请重试';
        });
    }
    sendVerifyMail(req) {
        console.log('[login] sendVerifyMail', req);
        const url = this.impl.buildUrl(this.getUrl('emailSendCode'), Object.assign({}, req));
        return this.impl
            .get(url, {}, {})
            .then(this.unpackLoginData.bind(this))
            .then(({ code, msgCode }) => {
            if (String(code) === '200') {
                return '';
            }
            return LoginApiImpl.getErrMsg(msgCode) || '发送失败，请重试';
        })
            .catch(reason => {
            console.warn(reason);
            return '发送失败，请重试';
        });
    }
    async doCorpSendMobileCode() {
        const { corpSid, currentPreloginRequest } = this.actions;
        const account = currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.account_name;
        const domain = currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.domain;
        const corpParams = await corpLoginUtils.getRequestParamsAsync({
            sid: corpSid,
            account,
            domain,
            deviceId: defaultLoginInfo.deviceid,
        });
        const requestData = Object.assign(Object.assign({}, defaultLoginInfo), corpParams);
        const defaultErrMsg = '发送失败，请重试';
        const corpSendPhoneCodeUrl = this.getUrl('coreMailSendPhoneCode');
        return this.impl
            .post(corpSendPhoneCodeUrl, requestData)
            .then(res => res.data)
            .then(res => {
            if (typeof res === 'object' && String(res.code) === corpLoginUtils.CONSTANTS.CORP_API_SUCCESS_CODE) {
                return '';
            }
            return LoginApiImpl.getErrMsg(res === null || res === void 0 ? void 0 : res.msgCode, defaultErrMsg);
        })
            .catch(err => {
            console.error('[login] doCorpSendMobileCode error', err);
            return defaultErrMsg;
        });
    }
    async doMobileVerifyCode(verifyCode, isRegister) {
        try {
            const url = this.impl.buildUrl(this.getUrl('mobileVerifyCode'), {
                code: verifyCode,
                p: productCode,
            });
            const res = await this.impl.post(url);
            const { code = '', msgCode, data } = this.unpackLoginData(res);
            if (code.toString() === '200') {
                const { accounts, unq_code } = data;
                this.actions.unqCode = unq_code;
                return {
                    success: true,
                    data: this.accountApi.doTransMobileBindAccountList(accounts),
                };
            }
            console.error('[login_impl] doMobileVerifyCode error', res);
            let message = LoginApiImpl.getErrMsg(msgCode);
            if (code === 500) {
                if (msgCode === 'ERR. LOGIN. MLOGINSMSREO') {
                    message = isRegister ? '当天已发送已发送10次' : '当天已发送已发送20次';
                }
                else if (msgCode === 'ERR.SESSIONNULL') {
                    message = '验证码已失效，请重新获取验证码';
                }
            }
            return {
                success: false,
                message,
                code: code.toString(),
            };
        }
        catch (e) {
            console.error('[login_impl] doMobileVerifyCode error', e);
            return {
                success: false,
                message: LoginApiImpl.commonCatch(e),
            };
        }
    }
    doSendVerifyCode(email, sessionName) {
        if (!email && this.actions.preLoginPassed && this.actions.currentPreloginRequest) {
            this.actions.codeRetryTime = 0;
            if (this.actions.currentPreloginRequest.type !== 1 && loginUtils.getIsCorpMailMode(this.actions.mailMode)) {
                return this.doCorpSendMobileCode();
            }
            return this.sendVerifyCode(this.actions.currentPreloginRequest).catch(LoginApiImpl.commonCatch);
        }
        if (email) {
            return this.sendVerifyCode(this.actions.subAccountCurrentPreLoginRequestMap[email], sessionName).catch(LoginApiImpl.commonCatch);
        }
        return Promise.resolve(ErrMsgCodeMap['ERR.ILLEGAL']);
    }
    doSendVerifyMail() {
        if (this.actions.preLoginPassed && this.actions.currentPreloginRequest) {
            return this.sendVerifyMail(this.actions.currentPreloginRequest).catch(LoginApiImpl.commonCatch);
        }
        return Promise.resolve(ErrMsgCodeMap['ERR.ILLEGAL']);
    }
    async doSendVerifyCert(email) {
        const { domain, account } = this.handleAccountAndDomain(email);
        if (!domain && !account) {
            return {
                success: false,
                message: ErrMsgCodeMap['ERR.ILLEGAL'],
            };
        }
        try {
            const res = await this.impl.get(this.getUrl('certLoginSendCode'), {
                p: 'sirius',
                domain,
                account_name: account,
                output: 'json',
            });
            const { code, msgCode } = this.unpackLoginData(res);
            if (String(code) === '200') {
                return {
                    success: true,
                };
            }
            return {
                success: false,
                message: LoginApiImpl.getErrMsg(msgCode) || '发送失败，请重试',
            };
        }
        catch (error) {
            console.error('[login_impl] doSendVerifyCert error', error);
            return {
                success: false,
                message: '发送失败，请重试',
            };
        }
    }
    async doLoginWithCertCode(email, code) {
        try {
            const { domain, account } = this.handleAccountAndDomain(email);
            if (!domain && !account) {
                return {
                    errmsg: ErrMsgCodeMap['ERR.ILLEGAL'],
                    pass: false,
                };
            }
            const params = {
                p: productCode,
                domain,
                account_name: account,
                code,
                output: 'json',
                autoEntry: true,
            };
            const getParams = {};
            this.fillSecRequestInfo(getParams);
            const url = this.impl.buildUrl(this.getUrl('certLoginVerifyCode'), getParams);
            const res = await this.impl.post(url, params, {});
            const ret = await this.processLoginResult(this.unpackLoginData(res));
            if (ret === null || ret === void 0 ? void 0 : ret.pass) {
                await this.tryReportLoginSuccess(email);
            }
            return ret;
        }
        catch (error) {
            return {
                pass: false,
                errmsg: LoginApiImpl.commonCatch(error),
            };
        }
    }
    loginWithCode(req) {
        let url = '';
        const { isSubAccount } = req;
        req.autoEntry = true;
        this.fillSecRequestInfo(req);
        if (isSubAccount) {
            if (process.env.BUILD_ISELECTRON && req && req.email && req.sessionName) {
                const sessionInfo = this.getUseSessionInfo(req.sessionName, req.sessionName);
                url = this.impl.buildUrl(this.getUrl('mobileLogin', req.email), sessionInfo);
            }
            if (process.env.BUILD_ISWEB) {
                url = this.getUrl('mobileLogin', req.email);
                this.fillAutoEntryAndNoCookieInfo(req);
            }
        }
        else {
            url = this.getUrl('mobileLogin');
        }
        return this.impl.post(url, req, {}).then(this.unpackLoginData.bind(this));
    }
    loginWithMail(req) {
        let url = '';
        req.autoEntry = true;
        this.fillSecRequestInfo(req);
        url = this.getUrl('emailLogin');
        return this.impl.post(url, req, {}).then(this.unpackLoginData.bind(this));
    }
    async doCorpLoginWithCode(phoneCode) {
        const { corpSid, currentPreloginRequest } = this.actions;
        const account = currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.account_name;
        const domain = currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.domain;
        const corpParams = await corpLoginUtils.getRequestParamsAsync({
            sid: corpSid,
            account,
            domain,
            deviceId: defaultLoginInfo.deviceid,
        });
        const requestData = Object.assign(Object.assign(Object.assign({}, defaultLoginInfo), corpParams), { code: phoneCode, passtype: 2 });
        const requestUrl = this.getUrl('corpMailPhoneCodeLogin');
        return this.impl
            .post(requestUrl, requestData)
            .then(res => res.data)
            .then(res => {
            const codeStr = String(res === null || res === void 0 ? void 0 : res.code);
            if (codeStr === corpLoginUtils.CONSTANTS.CORP_API_SUCCESS_CODE) {
                return this.handleLoginResponse(res === null || res === void 0 ? void 0 : res.data);
            }
            return {
                pass: false,
                errmsg: LoginApiImpl.getErrMsg(res === null || res === void 0 ? void 0 : res.msgCode),
                errCode: res === null || res === void 0 ? void 0 : res.msgCode,
                res,
            };
        })
            .then(async (rs) => {
            if (rs.pass) {
                await this.corpLoginSucceed(rs === null || rs === void 0 ? void 0 : rs.res);
            }
            return rs;
        })
            .catch(ex => {
            console.log('[login] corp-login with code error:', ex);
            return {
                errmsg: LoginApiImpl.commonCatch(ex),
                pass: false,
            };
        });
    }
    async doLoginWithCode(code, needPersist, email, sessionName) {
        const isSubAccount = !!email;
        if ((!isSubAccount && this.actions.preLoginPassed && this.actions.currentPreloginRequest) || isSubAccount) {
            const req = !isSubAccount ? this.actions.currentPreloginRequest : this.actions.subAccountCurrentPreLoginRequestMap[email];
            this.actions.loginMethod = 'code';
            if (!isSubAccount && this.actions.codeRetryTime > 3) {
                return Promise.resolve({
                    errmsg: ErrMsgCodeMap['ERR.MOBILEAUTH.RETRYFAILED'],
                    pass: false,
                });
            }
            if (loginUtils.getIsCorpMailMode(this.actions.mailMode)) {
                return this.doCorpLoginWithCode(code);
            }
            let reqDomain = '';
            let reqAccounName = '';
            if (isSubAccount) {
                const accountAndDomain = this.handleAccountAndDomain(email);
                reqDomain = accountAndDomain.domain;
                reqAccounName = accountAndDomain.account;
            }
            const res = await this.loginWithCode({
                p: req.p || productCode,
                domain: !isSubAccount ? req.domain : reqDomain,
                account_name: !isSubAccount ? req.account_name : reqAccounName,
                pass_2fa: (needPersist || 0),
                code,
                output: 'json',
                sessionName,
                email: isSubAccount ? email : '',
                isSubAccount,
            });
            if (isSubAccount) {
                this.fillSubAccountInfo(res, email, false, sessionName);
            }
            return this.processLoginResult(res).then(async (ret) => {
                if (ret === null || ret === void 0 ? void 0 : ret.pass) {
                    if (!isSubAccount) {
                        const { currentPreloginRequest } = this.actions;
                        const account = (currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.account_name) + '@' + (currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.domain);
                        await this.tryReportLoginSuccess(account);
                    }
                    else {
                        await this.tryReportLoginSuccess(email);
                    }
                }
                return ret;
            });
        }
        return Promise.resolve({
            errmsg: ErrMsgCodeMap['ERR.ILLEGAL'],
            pass: false,
        });
    }
    async doLoginWithMail(code, needPersist) {
        if (this.actions.preLoginPassed && this.actions.currentPreloginRequest) {
            const req = this.actions.currentPreloginRequest;
            this.actions.loginMethod = 'mail';
            const res = await this.loginWithMail({
                p: req.p || productCode,
                domain: req.domain,
                account_name: req.account_name,
                pass_2fa: (needPersist || 0),
                code,
                output: 'json',
            });
            return this.processLoginResult(res).then(async (ret) => {
                if (ret === null || ret === void 0 ? void 0 : ret.pass) {
                    const { currentPreloginRequest } = this.actions;
                    const account = (currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.account_name) + '@' + (currentPreloginRequest === null || currentPreloginRequest === void 0 ? void 0 : currentPreloginRequest.domain);
                    await this.tryReportLoginSuccess(account);
                }
                return ret;
            });
        }
        return Promise.resolve({
            errmsg: ErrMsgCodeMap['ERR.ILLEGAL'],
            pass: false,
        });
    }
    async doGetPasswordRules() {
        try {
            const currentUser = this.systemApi.getCurrentUser();
            const isAddAccountPage = this.systemApi.getIsAddAccountPage();
            if (currentUser && currentUser.id && (!this.actions.preLoginPassed || !this.actions.currentPreloginResponse)) {
                await this.doPreLogin(currentUser.id);
            }
            const pwdKey = (currentUser && !isAddAccountPage ? 'getPwdRuleAfterLogin' : 'getPwdRule');
            const resp = await this.impl.post(this.getUrl(pwdKey), { output: 'json' }, { headers: { 'Qiye-Header': 'anticsrf' } });
            const data = this.unpackLoginData(resp);
            if (data && data.code && String(data.code) === '200') {
                if (data.result) {
                    return {
                        pwdrule: data.result,
                        nickname: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.nickName) || '',
                        sign: '',
                    };
                }
                if (data.data) {
                    return data.data;
                }
                return {};
            }
            return {
                errmsg: LoginApiImpl.getErrMsg(data.msgCode),
            };
        }
        catch (ex) {
            console.warn('[login] getPwdRul error:', ex);
            return {
                errmsg: LoginApiImpl.commonCatch(ex),
            };
        }
    }
    async doCheckPasswordMatch(pwd, account) {
        if (account) {
            this.storeCurrentAccount({ account });
        }
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser) {
            return false;
        }
        const { pwd: curPwd, type } = await this.getS({
            originPwd: LoginApiImpl.accountPwdAutoFilled,
            originAccount: account || currentUser.id,
            md5Encrypt: true,
        });
        if (type !== 'plain' && type !== 'md5') {
            return false;
        }
        return !!pwd && !!curPwd && curPwd !== LoginApiImpl.accountPwdAutoFilled && (curPwd === pwd || curPwd === this.systemApi.md5(pwd));
    }
    async doUpdatePassword(pass, sign, oldPass) {
        try {
            const currentUser = this.systemApi.getCurrentUser();
            const isAddAccountPage = this.systemApi.getIsAddAccountPage();
            const hasLogin = currentUser && !isAddAccountPage;
            const pwdKey = (hasLogin ? 'updatePwdAfterLogin' : 'updatePwd');
            const loginedVar = {
                password: pass,
                old_pass: oldPass,
                passType: 0,
                passchange_req: 0,
                autoEntry: true,
            };
            const unloginVar = {
                output: 'json',
                pass,
                sign,
                autoEntry: true,
            };
            const dt = hasLogin ? loginedVar : unloginVar;
            const resp = await this.impl.post(this.getUrl(pwdKey), dt, {
                headers: { 'Qiye-Header': 'anticsrf' },
                noHeaderCookie: true,
            });
            const data = this.unpackLoginData(resp);
            if (String(data.code) === '200') {
                this.storePwd(pass);
                if (pwdKey === 'updatePwd') {
                    const ret = await this.processLoginResult(data);
                    if (ret === null || ret === void 0 ? void 0 : ret.pass) {
                        const preloginRequest = this.actions.currentPreloginRequest;
                        const account = (preloginRequest === null || preloginRequest === void 0 ? void 0 : preloginRequest.account_name) + '@' + (preloginRequest === null || preloginRequest === void 0 ? void 0 : preloginRequest.domain);
                        await this.tryReportLoginSuccess(account);
                    }
                    if (ret) {
                        ret.redirectUrl = 'entry';
                    }
                    return ret;
                }
                return { pass: true, errmsg: '' };
            }
            return {
                errmsg: (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.msgCodeDesc) || (data === null || data === void 0 ? void 0 : data.msgCode) || '',
                pass: false,
            };
        }
        catch (ex) {
            console.warn('[login] getPwdRul error:', ex);
            return Promise.resolve({
                errmsg: LoginApiImpl.commonCatch(ex),
                pass: false,
            });
        }
    }
    async processLoginResult(data) {
        var _a;
        let result;
        let loginResult;
        const isSubAccount = !!((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.isSubAccount);
        try {
            const rs = LoginApiImpl.processLogin(data);
            loginResult = this.handleLoginResponse(rs);
            const ckRes = checkMasterInfo();
            const judgeWay = (ckRes === null || ckRes === void 0 ? void 0 : ckRes.isMaster) || process.env.MOCK_ENV === 'mobile' ? 'header' : 'cookie';
            if (judgeWay === 'cookie') {
                result = await this.loginDoorEnter(loginResult);
            }
            else {
                result = await this.loginDoorEnterMobile(loginResult);
            }
        }
        catch (e) {
            console.log('[login] login error:', e);
            if (e && typeof e === 'string' && e === 'NETWORK.ERR.TIMEOUT') {
                result = {
                    pass: false,
                    timeout: true,
                    errmsg: '请求超时',
                };
            }
            else {
                result = {
                    errmsg: LoginApiImpl.commonCatch(e),
                    pass: false,
                };
            }
        }
        finally {
            if (!isSubAccount) {
                if ((loginResult === null || loginResult === void 0 ? void 0 : loginResult.pass) && !(result === null || result === void 0 ? void 0 : result.pass)) {
                    this.clearCookies(false);
                }
                if (result && this.actions.loginMethod !== 'code' && this.actions.loginMethod !== 'mail') {
                    const { secondCheck, showResetPass } = result;
                    if (!(secondCheck || showResetPass)) {
                        this.actions.preLoginPassed = false;
                    }
                }
            }
        }
        return result;
    }
    setPreLoginPassed(val) {
        if (this.actions) {
            this.actions.preLoginPassed = val;
        }
    }
    async doLogout(notDeleteAccount, clearCookies, noClearActionStore) {
        if (this.systemApi.isTransferringData() || this.systemApi.isBkLoginInit()) {
            return Promise.reject(new Error('not proper time to logout'));
        }
        try {
            console.trace('logout and clear cookie:', notDeleteAccount, clearCookies);
            this.dataTrackApi.track('pc_logout_occurred', {
                notDeleteAccount,
                clearCookies,
            });
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser) {
                return '';
            }
            this.impl.setLogoutStatus(true);
            if (!notDeleteAccount) {
                await this.accountApi.doDeleteAccountList([currentUser.id]);
            }
            this.disableBackgroundDB(true);
            const res = await this.sendLoginEvent(undefined);
            await this.storeApi.setLastAccount(undefined);
            const isCorpMailUser = this.systemApi.getIsCorpMailMode();
            await this.clearCookies(isCorpMailUser);
            return res;
        }
        catch (e) {
            console.error('[login] logout error ', e);
            return 'SERVER.ERR';
        }
        finally {
            this.storeApi.setCurrentNode(undefined);
            if (!noClearActionStore) {
                this.actions = new ActionStore();
            }
        }
    }
    async getLoginAccountInfo(emailAddress) {
        var _a, _b, _c, _d;
        try {
            const domainInfo = emailAddress ? this.handleAccountAndDomain(emailAddress) : { domain: '', account: '' };
            const url = this.systemApi.getUrl('loginGetAccount');
            const res = await this.impl
                .get(url, {
                domain: domainInfo.domain,
                account_name: domainInfo.account,
                output: 'json',
                p: productCode,
            })
                .then(res => res.data);
            const isSuccess = ((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200';
            const userInfo = (_b = res === null || res === void 0 ? void 0 : res.result) === null || _b === void 0 ? void 0 : _b.data;
            if (isSuccess && userInfo) {
                return {
                    success: true,
                    data: {
                        email: userInfo.email,
                        orgName: userInfo.orgName,
                        nickname: userInfo.nickName,
                        cookieName: '',
                    },
                };
            }
            try {
                this.dataTrackApi.track('jump_get_login_account_api_error', {
                    errorCode: (res === null || res === void 0 ? void 0 : res.code) || '',
                    errorMsg: ((_c = res === null || res === void 0 ? void 0 : res.result) === null || _c === void 0 ? void 0 : _c.message) || '',
                });
            }
            catch (ex) {
                console.error(ex);
            }
            return {
                success: false,
                error: {
                    errorCode: ((_d = res === null || res === void 0 ? void 0 : res.code) === null || _d === void 0 ? void 0 : _d.toString()) || '',
                    errorMsg: '',
                },
            };
        }
        catch (ex) {
            this.dataTrackApi.track('jump_get_login_account_api_error', {
                errorCode: 'catch-error',
                errorMsg: typeof ex === 'string' ? ex : (ex === null || ex === void 0 ? void 0 : ex.message) || '',
            });
            return {
                success: false,
                error: {
                    errorMsg: (ex === null || ex === void 0 ? void 0 : ex.message) || '',
                },
            };
        }
    }
    async doTryNewLoginWithCurrentState(emailAccount, sid, originAccount) {
        var _a, _b;
        try {
            const res = await this.getLoginAccountInfo(emailAccount);
            const resData = res.data;
            let nickname;
            let uid;
            let orgName;
            let cnName;
            if (!res.success || !resData) {
                if (!emailAccount) {
                    return {
                        pass: false,
                        errmsg: ((_a = res.error) === null || _a === void 0 ? void 0 : _a.errorMsg) || '认证异常，请登录后重试',
                        errCode: (_b = res.error) === null || _b === void 0 ? void 0 : _b.errorCode,
                    };
                }
                const accountInfo = this.handleAccountAndDomain(emailAccount);
                nickname = accountInfo.account;
                uid = emailAccount;
                orgName = '';
                cnName = '';
            }
            else {
                nickname = resData.nickname;
                uid = resData.email;
                orgName = resData.orgName;
                cnName = resData.cookieName;
            }
            this.actions.currentAccount = {
                a: uid,
                k: LoginApiImpl.accountPwdAutoFilled,
                lastLogin: Date.now(),
            };
            const originAccountEmail = originAccount && originAccount.includes('@') ? originAccount : '';
            await this.loginSucceed({
                uid,
                nickname,
                cookieName: sid,
                orgName,
                cnName,
                accessToken: '',
                accessSecret: '',
                isCorpMail: false,
                nonce: '',
                mobile: '',
                isSharedAccountSwitch: !!originAccountEmail,
                originAccountEmail,
            });
            return {
                pass: true,
                errmsg: '',
            };
        }
        catch (ex) {
            console.error('doTryNewLoginWithCurrentState error', ex);
            return {
                pass: false,
                errmsg: '认证异常，请登录后重试',
            };
        }
    }
    async doTryLoginWithCurrentState(emailAccount, sid, originAccount) {
        var _a;
        try {
            const shouldUseNewGetAccountInfo = typeof window !== 'undefined' ? window.loginUserNewAccountInfo : false;
            if (shouldUseNewGetAccountInfo) {
                return this.doTryNewLoginWithCurrentState(emailAccount, sid, originAccount);
            }
            const ret = await this.accountApi.getCurrentAccountInfo(emailAccount);
            await this.setupNodeInfo(ret.node);
            this.actions.currentAccount = {
                a: ret.email,
                k: LoginApiImpl.accountPwdAutoFilled,
                lastLogin: Date.now(),
            };
            let orgName = '';
            if (ret.unitPathList && ret.unitPathList.length > 0) {
                orgName = ((_a = ret.unitPathList[0]) === null || _a === void 0 ? void 0 : _a.unitName) || '';
            }
            const originAccountEmail = originAccount && originAccount.includes('@') ? originAccount : '';
            if (isWebmail && getIsJumpPage()) {
                this.noLoginEvent = true;
            }
            await this.loginSucceed({
                uid: ret.email,
                nickname: ret.nickName,
                cookieName: sid,
                orgName,
                cnName: '',
                accessToken: '',
                accessSecret: '',
                isCorpMail: false,
                nonce: '',
                mobile: '',
                isSharedAccountSwitch: !!originAccountEmail,
                originAccountEmail,
            });
            return {
                pass: true,
                errmsg: '',
            };
        }
        catch (e) {
            console.warn('[login] error load user info using cookies ', e);
            return {
                pass: false,
                errmsg: '认证异常，请登录后重试',
            };
        }
    }
    sendSubAccountExpiredEvent(info) {
        this.eventApi.sendSysEvent({
            eventName: 'SubAccountLoginPreExpired',
            toType: ['main'],
            eventData: {
                mainAccount: info === null || info === void 0 ? void 0 : info.mainAccount,
                subAccount: info === null || info === void 0 ? void 0 : info.subAccount,
                agentEmail: info === null || info === void 0 ? void 0 : info.agentEmail,
            },
        });
    }
    watchLogout(ev) {
        const isSubAccount = ev.eventName === 'subAccountLogout';
        if (isSubAccount && ev && ev.eventData) {
            this.sendSubAccountExpiredEvent(ev.eventData);
            return;
        }
        if (this.systemApi.isBkStableWindow()) {
            this.systemApi.closeWindow(false, true);
            return;
        }
        if (ev && pathNotInArrJudge(window.location, ignoreLoginPath) && !locationHelper.testPathMatch('/jump/')) {
            const eventData = (ev === null || ev === void 0 ? void 0 : ev.eventData) || {};
            this.logoutAndJump(Object.assign({ jumpTo: 'setting' }, eventData));
        }
    }
    async logoutAndJump(jumpConfig) {
        const { clearCookies = false, notDeleteAccount = true, jumpTo = 'setting' } = jumpConfig || {};
        console.trace('[login] logout called:', jumpConfig);
        if (this.systemApi.isBkLoginInit()) {
            return;
        }
        if (jumpTo === 'setting' && this.systemApi.isMainPage() && process.env.BUILD_ISELECTRON) {
            const func = (retry) => {
                jumpLogin(jumpConfig);
                setTimeout(() => {
                    console.warn('[login] logout navigate called:', jumpConfig, retry);
                    if (!locationHelper.testHrefMatch(loginPageExt)) {
                        if (retry > 0) {
                            func(retry - 1);
                        }
                        else {
                            jumpLogin();
                        }
                    }
                }, 2000);
            };
            func(3);
            return;
        }
        this.showAccountLogoutTip();
        this.doLogout(notDeleteAccount, clearCookies)
            .then(() => {
            this.jumpLogin();
        })
            .catch(ex => {
            console.error('logout occurred:', ex);
            this.dataTrackApi.track('auto_logout_exception_occured', { msg: ex === null || ex === void 0 ? void 0 : ex.message });
            this.jumpLogin();
        });
    }
    showAccountLogoutTip() {
        if (process.env.BUILD_ISWEB) {
            this.eventApi.sendSysEvent({
                eventName: 'error',
                eventData: {
                    popupType: 'toast',
                    popupLevel: 'error',
                    title: '登录账号已失效，即将跳转到登录页',
                },
            });
        }
    }
    async jumpLogin(jumpConfig) {
        this.noLoginStatus = true;
        await this.performanceApi.saveLog();
        if ((jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.jumpTo) === 'login') {
            this.logoutProcessing = true;
            await this.doLogout(jumpConfig.notDeleteAccount, jumpConfig.clearCookies);
            this.logoutProcessing = false;
        }
        jumpLogin(jumpConfig, () => {
            console.warn('[login] handle jump login finish and set flag');
            this.logoutProcessing = true;
        });
    }
    onPathChange(_) {
        return this.name;
    }
    reportLogoutToUser(jumpConfig) {
        this.doLogout(!!(jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.notDeleteAccount), !!(jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.clearCookies)).then();
    }
    refreshStatus() {
        this.actions.preLoginPassed = false;
    }
    async autoLoginSharedAccount(originEmail, sharedEmail) {
        return new Promise(async (resolve, _) => {
            try {
                const [account, accountInfo] = await this.accountApi.doGetAllAccountList();
                const swictAccount = (account || []).filter(item => item.id === originEmail);
                const browserUUId = this.storeApi.getUUID();
                const sessionName = `memory-${new Date().getTime().toString()}`;
                const { winId } = await this.systemApi.createWindowWithInitData({
                    type: 'bkLogin',
                    additionalParams: {
                        bkLoginInit: 'true',
                        sessionName,
                    },
                    manualShow: true,
                    sessionName,
                }, {
                    eventName: 'initBkLoginPage',
                    eventData: {
                        account: swictAccount,
                        accountInfo,
                        browserUUId,
                        accountId: originEmail,
                        isSharedAccountSwitch: true,
                        targetSharedAccount: sharedEmail,
                    },
                });
                let hasTimeout = false;
                const tid = setTimeout(() => {
                    hasTimeout = true;
                    resolve({
                        pass: false,
                        errMsg: '重登陆超时',
                    });
                }, 30 * 1000);
                const eventName = 'bkStableSwitchAccount';
                const eventId = this.eventApi.registerSysEventObserver(eventName, {
                    name: 'hanldSharedAccountLoginExpired-result',
                    func: async (ev) => {
                        if (hasTimeout)
                            return;
                        if (tid) {
                            window.clearTimeout(tid);
                        }
                        if (winId) {
                            this.systemApi.closeSubWindow(winId, false, true);
                        }
                        if (eventId) {
                            this.eventApi.unregisterSysEventObserver(eventName, eventId);
                        }
                        const data = ev.eventData;
                        const { currentUser, pass, account } = data;
                        if (pass) {
                            if (currentUser) {
                                const newCurrentUser = this.systemApi.getCurrentUser();
                                if (newCurrentUser) {
                                    this.storeApi.setLastAccount(newCurrentUser);
                                    if (newCurrentUser.cookies && newCurrentUser.cookies.length) {
                                        await window.electronLib.appManage.clearCookieStore();
                                        await window.electronLib.appManage.setCookieStore(newCurrentUser.cookies);
                                    }
                                }
                            }
                            if (account && account.length) {
                                await this.accountApi.storeAccountList(account);
                            }
                            resolve({
                                pass: true,
                            });
                        }
                        else {
                            return resolve({
                                pass: false,
                            });
                        }
                    },
                });
            }
            catch (ex) {
                resolve({
                    pass: false,
                    errMsg: ex.message,
                });
            }
        });
    }
    sendSubAccountLoginEvent(user, isTimeout) {
        this.eventApi.sendSysEvent({
            eventName: 'subAccountLogin',
            eventData: user,
            eventStrData: isTimeout ? 'timeout_event' : 'event',
        });
    }
    showWindowError(msg, title) {
        this.eventApi.sendSysEvent({
            eventName: 'error',
            eventLevel: 'error',
            eventStrData: '',
            eventData: {
                popupType: 'window',
                popupLevel: 'error',
                title: title || '错误提示',
                content: msg || '未知错误',
                code: 'PARAM.ERR',
                auto: false,
            },
        });
    }
    watchLoginExpired(ev) {
        console.log('got re-login ev:', ev);
        const { eventName } = ev;
        const isSubAccount = ev.eventName === 'subAccountLoginHttpExpired' || ev.eventName === 'subAccountLoginExpiredCrossWindow';
        const subAccount = ev.eventData && ev.eventData.subAccount ? ev.eventData.subAccount : '';
        const isMailPage = this.systemApi.isMainPage();
        if (process.env.BUILD_ISELECTRON &&
            !this.systemApi.isBkLoginInit() &&
            (eventName === 'loginExpired' || isSubAccount)) {
            if (!isSubAccount) {
                this.eventApi.sendSimpleSysEvent('loginExpiredCrossWindow');
            }
            else if (!isMailPage) {
                this.eventApi.sendSysEvent({
                    eventName: 'subAccountLoginExpiredCrossWindow',
                    eventData: ev.eventData,
                });
            }
        }
        const isLogout = !subAccount ? this.actions.logout : this.actions.subAccountLogoutMap[subAccount] || false;
        if (isLogout || this.systemApi.isTransferringData()) {
            console.log('[login] will not handle re-login ev:', ev);
            return;
        }
        const isAutoLogin = !subAccount ? this.actions.autoLogin : this.actions.subAccountAutoLoginMap[subAccount] || false;
        if (!isAutoLogin) {
            if (!subAccount) {
                this.actions.autoLogin = true;
            }
            else {
                this.actions.subAccountAutoLoginMap[subAccount] = true;
            }
            console.warn('[login] handle re-login ev:', ev);
            const isMailPage = this.systemApi.isMainPage();
            if ((isMailPage && process.env.BUILD_ISELECTRON) || !process.env.BUILD_ISELECTRON) {
                const currentUser = this.systemApi.getCurrentUser();
                if (!subAccount && currentUser && currentUser.isSharedAccount && currentUser.originAccount) {
                    this.autoLoginSharedAccount(currentUser.originAccount.email, currentUser.id)
                        .then(res => {
                        if (res.pass) {
                            const currentUser = this.systemApi.getCurrentUser();
                            if (currentUser) {
                                this.sendLoginEvent(currentUser, false, true);
                            }
                        }
                        else {
                            this.trackReLoginFailedToHubble('sharedAccount autoLogin error ' + (res.errMsg || ''));
                            this.triggerLogoutLogical(false);
                        }
                    })
                        .finally(() => {
                        this.actions.autoLogin = false;
                    });
                    return;
                }
                this.autoLogin(subAccount, isSubAccount)
                    .then(res => {
                    if (res.pass) {
                        if (isSubAccount) {
                            this.sendSubAccountLoginEvent(this.systemApi.getCurrentUser(subAccount));
                        }
                        console.log('[login] re-login success', ev, res);
                        return;
                    }
                    if (res.timeout) {
                        if (!subAccount) {
                            const currentUser = this.systemApi.getCurrentUser();
                            if (currentUser) {
                                this.sendLoginEvent(currentUser, true).then();
                                return;
                            }
                        }
                        else {
                            const currentUser = this.systemApi.getCurrentUser(subAccount);
                            if (currentUser) {
                                this.sendSubAccountLoginEvent(currentUser, true);
                                return;
                            }
                        }
                    }
                    this.trackReLoginFailedToHubble('autoLogin error ' + (res.errmsg || ''));
                    this.triggerLogoutLogical(isSubAccount, isSubAccount ? ev.eventData : undefined);
                })
                    .catch(res => {
                    console.warn('[login] re-login failed with exception :', res);
                    this.trackReLoginFailedToHubble('autoLogin catch error ' + (res.message || ''));
                    this.triggerLogoutLogical(isSubAccount, isSubAccount ? ev.eventData : undefined);
                })
                    .finally(() => {
                    if (!isSubAccount) {
                        this.actions.autoLogin = false;
                    }
                    else {
                        this.actions.subAccountAutoLoginMap[subAccount] = false;
                    }
                });
            }
        }
        else {
            console.warn('[login] re-login processing', ev);
        }
    }
    trackReLoginFailedToHubble(errMsg) {
        try {
            const upTime = getReLoginUpTime();
            const env = getCurrentPageEnv();
            this.dataTrackApi.track('pc_login_re_login_failed', {
                msg: errMsg,
                uptime: upTime,
                env,
                subType: 'reloginfailed',
            });
        }
        catch (ex) {
            console.error('trackReLoginFailedToHubble ex', ex);
        }
    }
    trackLogoutToHubble() {
        try {
            const upTime = getReLoginUpTime();
            this.dataTrackApi.track('pc_login_logout_occurred', {
                uptime: upTime,
                subType: 'reloginfailed',
            });
        }
        catch (ex) {
            console.error('trackLogoutToHubble login error', ex);
        }
    }
    triggerLogoutLogical(isSubAccount, subAccountIndfo) {
        this.trackLogoutToHubble();
        if (isSubAccount) {
            subAccountIndfo && this.sendSubAccountExpiredEvent(subAccountIndfo);
            return;
        }
        this.systemApi.unLockApp();
        this.logoutAndJump({
            clearCookies: true,
            notDeleteAccount: true,
            jumpTo: 'setting',
        });
    }
    init() {
        if (inWindow()) {
            this.loadUUID();
            if (this.systemApi.isMainPage()) {
                !LoginApiImpl.isInited &&
                    this.eventApi.registerSysEventObserver('loginExpiredCrossWindow', {
                        name: 'loginWatchLoginExpiredCross',
                        func: this.watchLoginExpired.bind(this),
                    });
                !LoginApiImpl.isInited &&
                    this.eventApi.registerSysEventObserver('subAccountLoginExpiredCrossWindow', {
                        name: 'loginImpl-subAccountLoginExpiredCrossWindow',
                        func: this.watchLoginExpired.bind(this),
                    });
            }
        }
        if (process.env.BUILD_ISELECTRON && !this.sysMacDeviceInfo) {
            this.systemApi.getDeviceMacInfo().then(res => {
                if (res) {
                    this.sysMacDeviceInfo = transferLocalDeviceToServerDevice(res);
                }
            });
        }
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('edmLogoutDevice', {
                name: 'edmLogoutDevice-login',
                func: ev => {
                    const isMailPage = this.systemApi.isMainPage();
                    if (!isMailPage)
                        return;
                    if (ev && ev.eventData) {
                        jumpLogin({
                            jumpTo: 'login',
                            clearCookies: true,
                            notDeleteAccount: true,
                        });
                    }
                },
            });
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('loginExpired', {
                name: 'loginWatchLoginExpired',
                func: this.watchLoginExpired.bind(this),
            });
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('subAccountLoginHttpExpired', {
                name: 'subAccountLoginWatchLoginExpired',
                func: this.watchLoginExpired.bind(this),
            });
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('logout', {
                name: 'loginWatchLogout',
                func: this.watchLogout.bind(this),
            });
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('subAccountLogout', {
                name: 'loginImpl-subAccountLogout',
                func: this.watchLogout.bind(this),
            });
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('loginBlock', {
                name: 'loginNoLoginStatusOb',
                func: ev => {
                    if (ev && ev.eventData !== undefined) {
                        this.noLoginStatus = String(ev.eventData) === 'true';
                    }
                },
            });
        !LoginApiImpl.isInited &&
            this.eventApi.registerSysEventObserver('loginRetry', {
                name: 'loginWatchRetryOb',
                func: async () => {
                    try {
                        const user = this.systemApi.getCurrentUser();
                        if (user && user.id) {
                            const ret = await this.accountApi.getCurrentAccountInfo(user === null || user === void 0 ? void 0 : user.id);
                            if (ret.email) {
                                this.impl.afterLogin &&
                                    this.impl.afterLogin({
                                        event: 'afterLogin',
                                        data: {
                                            eventName: 'login',
                                            eventData: user,
                                            eventSeq: 0,
                                            eventStrData: 'timeout_event',
                                        },
                                    });
                            }
                            console.warn('[login] login retry succeed', ret);
                        }
                    }
                    catch (e) {
                        console.error('[login] login retry failed', e);
                        this.triggerLogoutLogical(false);
                    }
                },
            });
        !LoginApiImpl.isInited &&
            this.systemApi.intervalEvent({
                eventPeriod: 'mid',
                seq: 0,
                id: 'login_watch_dog',
                noUserAuth: true,
                handler: (ev) => {
                    if (ev.seq > 7 && ev.seq % 3 === 0) {
                        if (!this.noLoginStatus) {
                            this.handleNoCurrentUser();
                        }
                    }
                },
            });
        LoginApiImpl.isInited = true;
        return this.name;
    }
    handleNoCurrentUser() {
        if (this.systemApi.getCurrentUser() == null) {
            setTimeout(() => {
                if (this.systemApi.getCurrentUser() == null && !this.noLoginStatus) {
                    this.notifyNoLogin();
                }
            }, 7700);
        }
    }
    notifyNoLogin() {
        if (pathNotInArrJudge(window.location, ignoreLoginPath)) {
            if (this.actions.loginIssueConfirmShowed) {
                this.actions.loginIssueConfirmShowed = true;
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'window',
                        popupLevel: 'error',
                        title: '登录状态异常',
                        content: '将跳转至账号管理页，跳转后可尝试重新登录',
                        code: 'PARAM.ERR',
                        auto: false,
                        btnConfirmTxt: '立即跳转',
                        confirmCallback: () => {
                            if (this.systemApi.isMainPage()) {
                                this.actions.loginIssueConfirmShowed = false;
                                this.jumpLogin({
                                    jumpTo: 'setting',
                                    clearCookies: false,
                                    notDeleteAccount: true,
                                });
                            }
                            else if (window.electronLib && this.systemApi.isElectron()) {
                                this.systemApi.closeWindow(true);
                            }
                        },
                        cancelCallback: () => {
                            this.actions.loginIssueConfirmShowed = false;
                            console.warn('user cancel the dialog of login alert');
                            this.dataTrackApi.track('pc_logout_alerted_and_canceled_by_user', {
                                location: window.location.href,
                            });
                        },
                    },
                    eventSeq: 0,
                });
            }
            else {
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'toast',
                        popupLevel: 'error',
                        title: '登录状态异常',
                        content: '请确认是否请求出现异常',
                        code: 'PARAM.ERR',
                        auto: false,
                    },
                    eventSeq: 0,
                });
            }
        }
        if (this.systemApi.isBkStableWindow()) {
            this.systemApi.closeWindow(false, true);
        }
    }
    afterInit() {
        this.autoFillPwdMd5 = this.systemApi.md5(LoginApiImpl.accountPwdAutoFilled, true);
        return this.name;
    }
    sendAccountInitModuleEvent() {
        this.eventApi.sendSysEvent({
            eventName: 'initModule',
            eventStrData: 'account',
        });
    }
    async getSecCertSn() {
        var _a;
        try {
            const currentId = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
            if (!currentId)
                return undefined;
            const secCertInfo = await this.accountApi.doGetSecCertInfoById(currentId);
            if (secCertInfo) {
                return secCertInfo === null || secCertInfo === void 0 ? void 0 : secCertInfo.sn;
            }
        }
        catch (ex) {
            console.error('getSecCertSn-ex', ex);
        }
        return undefined;
    }
    async setCheckDeviceInterval(minutes) {
        try {
            const res = await this.storeApi.putToDB(CHECK_DEVICE_INTERVAL_DBKEY, minutes.toString(), globalStoreConfig);
            return res;
        }
        catch (ex) {
            console.error('setDefaultCheckDeviceInterval-catch', ex);
        }
    }
    async getCheckDeviceInterval() {
        try {
            const data = await this.storeApi.getFromDB(CHECK_DEVICE_INTERVAL_DBKEY, globalStoreConfig);
            if (data && data.suc && data.data) {
                return Number.parseInt(data.data);
            }
            return DEFAULT_CHECK_DEVICE_INTERVAL;
        }
        catch (ex) {
            console.error('getCheckDeviceInterval-catch', ex);
            return DEFAULT_CHECK_DEVICE_INTERVAL;
        }
    }
    async checkSecDeviceFromServer(email) {
        try {
            const url = this.getUrl('loginCheckSecDeviceInfo', email);
            const req = {};
            this.fillSecRequestInfo(req);
            const param = {
                secMdc: req && req.secMdc ? req.secMdc : '',
            };
            if (!email) {
                const secCertSn = await this.getSecCertSn();
                if (secCertSn) {
                    param.secCertSn = secCertSn;
                }
            }
            const { data } = await this.impl.get(url, param, { _account: email || '' });
            if (!email) {
                lastCheckDeviceTs = new Date().getTime();
            }
            if (data && data.data) {
                const { checkInterval } = data.data;
                if (checkInterval) {
                    await this.setCheckDeviceInterval(checkInterval);
                }
            }
            if (data && data.msgCode) {
                const errCode = data.msgCode;
                const errMsg = data.msgCodeDesc || '';
                const cerf_error = 'ERR.SECCERT.INVALID';
                const require_mdc_error = 'LOGIN.SEC.REQUIREMDC';
                const shouldLogout = errCode === cerf_error || errCode === SEC_DEVICE_LOGOUT_CODE || errCode === 'LOGIN.SEC.REPORT' || errCode === require_mdc_error;
                return {
                    success: true,
                    shouldLogout,
                    shouldCleanCert: errCode === cerf_error,
                    errorMsg: errMsg,
                };
            }
            return {
                success: false,
            };
        }
        catch (ex) {
            console.error('checkSecDeviceFromServer-catch', ex);
            return {
                success: false,
            };
        }
    }
    async checkSecCertExpired(force) {
        try {
            const currentUser = this.systemApi.getCurrentUser();
            if (!process.env.BUILD_ISLINGXI || !process.env.BUILD_ISELECTRON || !currentUser)
                return;
            const secCertInfo = await this.accountApi.doGetSecCertInfoById(currentUser.id);
            if (!secCertInfo)
                return;
            const { sn: secCertSn, expTime } = secCertInfo;
            const now = Date.now();
            if (force || now + 30 * 24 * 60 * 60 > expTime) {
                const { account, domain } = this.handleAccountAndDomain(currentUser.id);
                const { data } = await this.impl.get(this.getUrl('certLoginReplace'), {
                    domain,
                    account_name: account,
                    output: 'json',
                    p: productCode,
                    secCertSn,
                });
                if ((data === null || data === void 0 ? void 0 : data.code) === 200 && data.data) {
                    if (data.data.status === 0) {
                        await this.accountApi.doSaveSecCertInfo(currentUser.id, undefined);
                    }
                    else {
                        await this.accountApi.doSaveSecCertInfo(currentUser.id, {
                            sn: data.data.sn,
                            priKey: data.data.priKey,
                            pubKey: data.data.pubKey,
                            expTime: data.data.expTime,
                            status: data.data.status,
                        });
                    }
                }
            }
        }
        catch (error) {
            console.error('[login_impl] checkSecCertExpired error', error);
        }
    }
    async checkSecDeviceLogout() {
        try {
            if (!this.needCheckSecCert)
                return;
            const isMainPage = this.systemApi.isMainPage();
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser || !isMainPage)
                return;
            const res = await this.checkSecDeviceFromServer();
            if (res.success && res.shouldCleanCert) {
                this.accountApi.doSaveSecCertInfo(currentUser.id, undefined);
            }
            if (res.success && res.shouldLogout) {
                this.handleEDMDeviceLogout({
                    mesage: res.errorMsg || '该账号的登录证书已失效，已自动退出登录，如需继续使用请重新登录',
                    isCertInvalid: res.shouldCleanCert,
                    code: 200,
                });
            }
            const subAccountList = this.storeApi.getSubAccountList();
            if (subAccountList && subAccountList.length) {
                subAccountList.forEach(async (item) => {
                    const { email, agentEmail } = item;
                    const isThirdAccount = this.systemApi.getIsThirdSubAccountByEmailId(email);
                    if (!isThirdAccount) {
                        const res = await this.checkSecDeviceFromServer(email);
                        if (res.success && res.shouldLogout) {
                            this.triggerLogoutLogical(true, {
                                mainAccount: currentUser.id,
                                agentEmail,
                                subAccount: email,
                            });
                        }
                    }
                });
            }
        }
        catch (ex) {
            console.error('checkSecDeviceLogout-catch-err', ex);
        }
    }
    bindAccountDeviceOnWake() {
        const nowTs = new Date().getTime();
        if (nowTs - lastBindDeviceAccountTs > 1000 * 60 * 60) {
            setTimeout(() => {
                this.bindAccountDevice();
            }, 5000);
        }
    }
    watchResumeAndOnline() {
        if (this.hasWatchResumeAndOnline)
            return;
        let shouldWatchOnline = false;
        if (process.env.BUILD_ISELECTRON) {
            if (this.systemApi.isMainPage()) {
                this.systemApi.addWindowHooks('onLaptopResume', () => {
                    this.bindAccountDeviceOnWake();
                });
                shouldWatchOnline = true;
            }
        }
        else if (process.env.BUILD_ISWEB) {
            shouldWatchOnline = true;
        }
        if (shouldWatchOnline) {
            window.addEventListener('online', () => {
                this.bindAccountDeviceOnWake();
            });
        }
        this.hasWatchResumeAndOnline = true;
    }
    checkShouldSwitchToSharedAccount() {
        if (process.env.BUILD_ISELECTRON)
            return;
        try {
            const { hash } = location;
            if (hash && hash.includes('?')) {
                const params = new URLSearchParams(hash.split('?')[1]);
                if (params) {
                    const module = params.get('m');
                    if (module === 'shared_account') {
                        const sharedAccount = params.get('semail');
                        if (sharedAccount && sharedAccount.length) {
                            this.switchSharedAccount(sharedAccount).then(res => {
                                if (!res.success) {
                                    const errorMsg = `登录公共账号${sharedAccount}出错：${res.errMsg || '未知错误'}`;
                                    alert(errorMsg);
                                }
                            });
                        }
                    }
                }
            }
        }
        catch (ex) {
            console.error('checkShouldSwitchToSharedAccount-catch', ex);
        }
    }
    afterLoadFinish() {
        this.checkShouldSwitchToSharedAccount();
        this.checkSecDeviceLogout();
        this.checkSecCertExpired();
        this.checkShouldShowLogoutTip();
        this.watchResumeAndOnline();
        if (process.env.BUILD_ISELECTRON && process.env.BUILD_ISLINGXI) {
            const isMainPage = this.systemApi.isMainPage();
            if (isMainPage) {
                this.systemApi.intervalEvent({
                    seq: 0,
                    eventPeriod: 'long',
                    id: 'login-checkSecDeviceLogout',
                    handler: async (ev) => {
                        if (ev.seq > 1) {
                            const interval = await this.getCheckDeviceInterval();
                            const nowTs = new Date().getTime();
                            if (nowTs >= interval * 60 * 1000 + lastCheckDeviceTs) {
                                this.checkSecDeviceLogout();
                                this.checkSecCertExpired();
                            }
                        }
                    },
                });
            }
        }
        this.loadStorageToDB()
            .then(_ => {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            !isCorpMail && this.bindAccountDevice().then();
            const user = this.systemApi.getCurrentUser();
            if (user === null || user === void 0 ? void 0 : user.id) {
                return this.getAccountStored(user.id);
            }
            return undefined;
        })
            .then(storedAccount => {
            if (storedAccount) {
                this.storeCurrentAccount({
                    account: storedAccount.id,
                    pwd: storedAccount.pwd,
                    mobile: storedAccount.mobile,
                    refreshToken: storedAccount.refreshToken,
                    refreshTokenExpire: storedAccount.refreshTokenExpire,
                });
            }
            if (environment !== 'prod') {
                console.log('[login] current account:', storedAccount);
            }
            if (process.env.BUILD_ISELECTRON && (storedAccount === null || storedAccount === void 0 ? void 0 : storedAccount.id) && !(storedAccount === null || storedAccount === void 0 ? void 0 : storedAccount.cookies)) {
                try {
                    const sessionName = this.systemApi.getCurrentSessionName();
                    const param = sessionName ? { sessionName } : undefined;
                    window.electronLib.appManage.getCookieStore(param).then(res => {
                        this.accountApi.doUpdateAccountList([
                            {
                                id: storedAccount === null || storedAccount === void 0 ? void 0 : storedAccount.id,
                                cookies: res,
                            },
                        ]);
                    });
                }
                catch (e) {
                    console.warn(e);
                }
            }
        })
            .catch(err => {
            console.error(err);
        })
            .finally(() => {
            this.sendAccountInitModuleEvent();
            this.logoutProcessing = false;
        });
        return this.name;
    }
    async setDeviceId(deviceId) {
        defaultLoginInfo.deviceid = deviceId;
        return this.storeUUID(deviceId)
            .then(() => this.storeApi.loadUUID())
            .then(() => this.impl.updateDeviceInfo())
            .catch(err => {
            console.error('setDeviceId error', err);
        });
    }
    storeUUID(uuid) {
        return this.storeApi.put(LoginApiImpl.keyDeviceUUID, uuid, LoginApiImpl.storeConfig);
    }
    loadUUID() {
        this.storeApi.get(LoginApiImpl.keyDeviceUUID, LoginApiImpl.storeConfig).then((rs) => {
            if (rs.suc && rs.data) {
                defaultLoginInfo.deviceid = rs.data;
            }
            else {
                const uuid = 'i-' + new Date().getTime().toString(16) + '-' + this.systemApi.generateKey(16);
                this.storeUUID(uuid).then(() => {
                    defaultLoginInfo.deviceid = uuid;
                });
            }
        });
    }
    sendEdmDeviceLogoutEvent(logoutInfo) {
        this.eventApi.sendSysEvent({
            eventName: 'edmLogoutDevice',
            eventData: logoutInfo,
        });
    }
    deleteGlobalKeyFromDBStorage(key) {
        try {
            this.storeApi.delFromDB(key, globalStoreConfig);
        }
        catch (ex) {
            console.error('deleteLogoutTip-catch', ex);
        }
    }
    async checkShouldShowLogoutTip() {
        try {
            const isLoginPage = getIsLoginPage();
            if (!isLoginPage)
                return;
            let tipKey = '';
            if (process.env.BUILD_ISEDM) {
                tipKey = EDM_LOGOUT_DEVICE_KEY;
            }
            else if (process.env.BUILD_ISLINGXI && process.env.BUILD_ISELECTRON) {
                tipKey = LINGXI_LOGOUT_DEVICE_KEY;
            }
            if (!tipKey)
                return;
            const tipInfo = await this.storeApi.getFromDB(tipKey, globalStoreConfig);
            if (tipInfo.suc && tipInfo.data) {
                const tipObj = JSON.parse(tipInfo.data);
                this.eventApi.sendSysEvent({
                    eventName: 'edmLogoutDeviceMsg',
                    eventData: tipObj,
                });
                this.deleteGlobalKeyFromDBStorage(tipKey);
            }
        }
        catch (ex) {
            console.error('checkShouldShowLogoutTip-error', ex);
        }
    }
    handleEDMDeviceLogout(data) {
        try {
            let logoutInfo = null;
            if (data === null || data === void 0 ? void 0 : data.isCertInvalid) {
                logoutInfo = { message: data.mesage, title: '提示' };
            }
            else if (process.env.BUILD_ISEDM) {
                const EDM_DEVICE_LOGOUT_CODE = '401001';
                const EDM_DEFAULT_LOGOUT_MSG = '检测到该账户已在多个设备或浏览器上登录，为了安全起见，请重新登录以继续使用。';
                if (data && data.code.toString() === EDM_DEVICE_LOGOUT_CODE) {
                    const logoutMsg = data.mesage || EDM_DEFAULT_LOGOUT_MSG;
                    logoutInfo = { message: logoutMsg, title: '提示' };
                }
            }
            else if (this.needCheckSecCert) {
                logoutInfo = { message: '该账号的登录设备不符合企业安全需求，已自动退出登录，如需继续使用请联系管理员', title: '提示' };
            }
            if (logoutInfo) {
                this.storeApi.putToDB(process.env.BUILD_ISEDM ? EDM_LOGOUT_DEVICE_KEY : LINGXI_LOGOUT_DEVICE_KEY, JSON.stringify(logoutInfo), globalStoreConfig).then(() => {
                    this.sendEdmDeviceLogoutEvent(logoutInfo);
                });
                this.dataTrackApi.track(process.env.BUILD_ISEDM ? 'edm_device_limit_logout' : 'lingxi_device_logout');
            }
        }
        catch (ex) {
            console.error('handleEDMDeviceLogout-error', ex);
        }
    }
    async bindAccountDevice() {
        var _a;
        if (process.env.BUILD_ISPREVIEWPAGE)
            return;
        if (isWebmail && getIsJumpPage())
            return;
        const currentUser = this.systemApi.getCurrentUser();
        const deviceInfo = await this.systemApi.getDeviceInfo();
        if (!currentUser || !deviceInfo._deviceId) {
            return;
        }
        try {
            const accountList = await this.accountApi.doGetAllMainAndSubAccounts();
            const mainAccountId = currentUser.id;
            let sharedAccounts = [];
            const sharedAccountInfo = await this.accountApi.getSharedAccountsInfoAsync();
            if ((_a = sharedAccountInfo === null || sharedAccountInfo === void 0 ? void 0 : sharedAccountInfo.sharedAccounts) === null || _a === void 0 ? void 0 : _a.length) {
                sharedAccounts = sharedAccountInfo.sharedAccounts.map(item => ({
                    bizAccountId: item.email,
                    bindType: 'EMAIL',
                    loginStatus: mainAccountId === item.email ? 1 : 0,
                }));
            }
            const bindAccountList = accountList.map(item => ({
                bizAccountId: item.id,
                bindType: 'EMAIL',
                loginStatus: mainAccountId === item.id ? 1 : 0,
            }));
            const needBindAccountList = sharedAccounts.length ? [...sharedAccounts, ...bindAccountList] : bindAccountList;
            if (!needBindAccountList || !needBindAccountList.length) {
                return;
            }
            const { data } = await this.impl.post(this.getUrl('bindAccountDevice'), {
                product: PUSH_PRODUCT,
                bindAccountList: needBindAccountList,
            }, {
                contentType: 'json',
            });
            if (data && data.success) {
                console.log('[login] bindAccountDevice Success! bindAccountList', bindAccountList);
                lastBindDeviceAccountTs = new Date().getTime();
            }
            else {
                if (process.env.BUILD_ISEDM) {
                    this.handleEDMDeviceLogout(data);
                }
                console.error('[login] bindAccountDeviceError', data === null || data === void 0 ? void 0 : data.message);
            }
        }
        catch (ex) {
            console.error('[login] +bindAccountDeviceError', ex);
        }
    }
    requestReportSuccApi(account) {
        return this.impl.post(this.systemApi.getUrl('notifyLoginSuc'), { account }, { timeout: 1000 });
    }
    getVerifyCodeUrl(accountName, accountDomain, sid) {
        const baseUrl = this.getUrl('corpMailGetVerifyCode');
        return corpLoginUtils.getNewImgVerifyCodeUrl({
            baseUrl,
            accountName,
            accountDomain,
            sid,
        });
    }
    async registerAddAccountPageReturnEvent() {
        if (this.addAccountEventId) {
            return;
        }
        this.addAccountEventId = this.eventApi.registerSysEventObserver('addAccountPageReturnEvent', {
            func: async (ev) => {
                const { eventData } = ev;
                if (eventData) {
                    this.disableBackgroundDB();
                    const { currentUser, currentNode, originAccount: newAccounts, originAccountInfo: newAccountInfos, originAccountSecInfo, authInfo } = eventData;
                    this.systemApi.switchLoading(true);
                    await this.eventApi.sendSysEvent({
                        eventName: 'loginBlock',
                        eventData: true,
                        eventSeq: 0,
                    });
                    await wait(10);
                    this.impl.setLogoutStatus(true);
                    if (currentUser) {
                        this.storeApi.setLastAccount(currentUser);
                    }
                    if (currentNode) {
                        this.storeApi.setCurrentNode(currentNode);
                    }
                    if (newAccounts && newAccounts.length) {
                        newAccounts.forEach(accountItem => {
                            accountItem.expired = false;
                        });
                        this.accountApi.doUpdateAccountList(newAccounts);
                    }
                    if (newAccountInfos && newAccountInfos.length) {
                        this.accountApi.storeAccountInfoList(newAccountInfos);
                    }
                    if (originAccountSecInfo && originAccountSecInfo.length) {
                        this.accountApi.storeAccountSecInfoList(originAccountSecInfo);
                    }
                    if (authInfo) {
                        this.productAuthApi.setStoreAuthInfo(authInfo);
                    }
                    if (window && window.electronLib && currentUser) {
                        this.systemApi.switchLoading(true);
                        const { electronLib } = window;
                        await electronLib.windowManage.show();
                        await electronLib.appManage.clearCookieStore();
                        await electronLib.appManage.setCookieStore(currentUser.cookies);
                        await electronLib.windowManage.closeAllWindowExceptMain(true);
                        try {
                            await electronLib.masterBridgeManage.flush('');
                        }
                        catch (ex) {
                            console.error('masterBridgeManage.flush error', ex);
                        }
                        setTimeout(async () => {
                            await this.createBKStableWindow();
                            this.systemApi.reloadToMainPage();
                        }, 200);
                    }
                }
            },
        });
    }
    async showCreateAccountPage(email) {
        if (!window)
            return;
        const currentHostType = this.systemApi.getCurrentHostType();
        const currentUser = this.systemApi.getCurrentUser();
        const browserUUId = this.storeApi.getUUID();
        const sessionName = `memory-${new Date().getTime().toString()}`;
        this.registerAddAccountPageReturnEvent();
        const allVisibleWins = await this.getAllWindowsByVisible(true, ['addAccount']);
        this.toggleAllWindows(allVisibleWins, false);
        const bounds = await window.electronLib.windowManage.getWinBounds();
        this.systemApi.createWindowWithInitData({
            type: 'addAccount',
            additionalParams: Object.assign({ 'add-account-page': 'true', 'lang-str': window.systemLang }, (email ? { 'login-email': email } : {})),
            sessionName,
            bounds,
        }, {
            eventName: 'initAddAccountPageEvent',
            eventData: {
                currentHostType,
                currentUser,
                browserUUId,
                sessionName,
                visibileWinIds: allVisibleWins,
            },
        });
    }
    async getAllWindowsByVisible(visible, blackWinTypes = []) {
        if (!window || !window.electronLib)
            return [];
        const { windowManage } = window.electronLib;
        const allWinInfos = await windowManage.getAllWinInfo();
        const winIds = [];
        allWinInfos.forEach(winInfo => {
            const currentWinId = winInfo.id;
            if (winInfo.isVisible === visible && !winIds.includes(currentWinId)) {
                const inBlackList = !blackWinTypes || !blackWinTypes.length ? false : blackWinTypes.includes(winInfo.type);
                if (!inBlackList) {
                    winIds.push(currentWinId);
                }
            }
        });
        return winIds;
    }
    async toggleAllWindows(winIds, visible) {
        if (!winIds || !winIds.length)
            return;
        if (!window || !window.electronLib)
            return;
        const { windowManage } = window.electronLib;
        winIds.forEach(winId => {
            if (visible) {
                windowManage.show(winId);
            }
            else {
                windowManage.hide(winId);
            }
        });
    }
    getCommonBindWinData() {
        const sessionName = `memory-${new Date().getTime().toString()}`;
        return {
            sessionName,
        };
    }
    sendSubAccountAddedEvent(param) {
        this.eventApi.sendSysEvent({
            eventName: 'SubAccountAdded',
            eventData: param,
        });
        setTimeout(() => {
            this.eventApi.sendSysEvent({
                eventName: 'SubAccountWindowReady',
                eventData: param,
            });
        }, 1000);
    }
    async handleAddSubAccountSuccess(uid, resolve, bindInfo) {
        const currentUser = this.systemApi.getCurrentUser();
        const mainAccount = currentUser ? currentUser.id : '';
        if (!mainAccount) {
            resolve({
                success: false,
                errMsg: DEFAULT_API_ERROR,
                errCode: 100,
            });
            return;
        }
        const accountTypeFromParam = typeof bindInfo === 'string' ? bindInfo : bindInfo.accountType;
        if (accountTypeFromParam === SUB_ACCOUNT_TYPES.NETEASE_QIYE_MAIL) {
            const isEditSubAccount = typeof bindInfo === 'object' && bindInfo.isEditMode;
            if (!isEditSubAccount) {
                const res = await this.addQiyeMailSubAccount(uid);
                if (!res.success) {
                    this.accountApi.deleteSubAccountLocalStateByEmail(uid);
                    resolve(res);
                    return;
                }
            }
            else {
                const res = await this.updateQiyeMailSubAccount(uid);
                if (!res.success) {
                    resolve(res);
                    return;
                }
            }
        }
        const agentEmail = typeof bindInfo === 'string' ? uid : bindInfo.agentEmail;
        if (currentUser) {
            const accountType = accountTypeFromParam === SUB_ACCOUNT_TYPES.NETEASE_QIYE_MAIL ? 'qyEmail' : 'personalEmail';
            if (typeof bindInfo !== 'string' && bindInfo.password) {
                bindInfo.password = '';
            }
            const newSubAccount = {
                mainAccount: currentUser.id,
                accountType,
                mainSendReceiveInfo: typeof bindInfo === 'string' ? {} : bindInfo,
                agentEmail: accountTypeFromParam === SUB_ACCOUNT_TYPES.NETEASE_QIYE_MAIL ? uid : agentEmail,
                id: uid,
                expired: false,
            };
            await this.accountApi.addOrUpdateLocalSubAccounts([newSubAccount]);
        }
        const eventParam = {
            mainAccount,
            subAccount: uid,
            agentEmail,
        };
        this.sendSubAccountAddedEvent(eventParam);
        resolve({
            success: true,
        });
    }
    async syncSubAccountLoginStatus(subAccount) {
        try {
            if (!subAccount.expired) {
                return {
                    success: true,
                };
            }
            if (!subAccount.verified && subAccount.accountType === 'qyEmail') {
                return {
                    success: false,
                    errCode: 600,
                    errMsg: '账号需重新验证',
                };
            }
            if (!subAccount.agentEmail) {
                return {
                    success: false,
                    errCode: 400,
                    errMsg: '子账号邮箱为空',
                };
            }
            let params;
            const commonParam = {
                isEditMode: true,
                password: '',
                isSyncLogin: true,
            };
            if (subAccount.accountType === 'qyEmail') {
                params = Object.assign({ accountType: SUB_ACCOUNT_TYPES.NETEASE_QIYE_MAIL, agentEmail: subAccount.agentEmail }, commonParam);
            }
            else {
                params = Object.assign({ agentNickname: subAccount.agentNickname, sendHost: subAccount.sendHost, sendPort: subAccount.sendPort, sendSsl: subAccount.sendSsl, receiveProtocol: subAccount.receiveProtocol, receiveHost: subAccount.receiveHost, receivePort: subAccount.receivePort, receiveSsl: subAccount.receiveSsl, accountType: SUB_ACCOUNT_TYPES.OTHERS, agentEmail: subAccount.agentEmail }, commonParam);
            }
            if (!params) {
                return {
                    success: false,
                    errCode: 501,
                    errMsg: '子账号参数错误',
                };
            }
            const result = await this.bindSubAccount(params);
            return result;
        }
        catch (ex) {
            console.error('syncSubAccountLoginStatus-error', ex);
            return {
                success: false,
                errMsg: ex && ex.message ? ex.message : '同步子账号登录态出错',
                errCode: 500,
            };
        }
    }
    bindSubAccountMail(bindInfo) {
        return new Promise(async (resolve, _) => {
            try {
                if (bindInfo) {
                    if (bindInfo.agentEmail) {
                        bindInfo.agentEmail = bindInfo.agentEmail.trim();
                    }
                    if (bindInfo.password) {
                        bindInfo.password = bindInfo.password.trim();
                    }
                }
                const mainAccount = this.systemApi.getCurrentUser();
                if (!mainAccount) {
                    resolve({
                        success: false,
                        errMsg: '获取主账号失败',
                        errCode: 300,
                    });
                    return;
                }
                const { sessionName } = this.getCommonBindWinData();
                const isQiyeMail = bindInfo.accountType === SUB_ACCOUNT_TYPES.NETEASE_QIYE_MAIL;
                if (!isQiyeMail || bindInfo.isSyncLogin) {
                    const res = bindInfo.isEditMode ? { success: true } : await this.addPersonalMailSubAccount(bindInfo);
                    if (!res.success) {
                        resolve(res);
                        return;
                    }
                    this.loginAgentEmail(bindInfo.agentEmail, '', sessionName, isQiyeMail ? SUBACCOUNT_LOGINTYPE.NETEASE_QIYE_MAIL : SUBACCOUNT_LOGINTYPE.OTHERS)
                        .then(res => {
                        if (res.success) {
                            const uid = res.data ? res.data.email : '';
                            this.handleAddSubAccountSuccess(uid, resolve, bindInfo);
                        }
                        else {
                            resolve(res);
                        }
                    })
                        .catch(err => {
                        resolve({
                            success: false,
                            errCode: 'loginAgentEmail-Catch',
                            errMsg: (err && err.message) || '登录失败',
                        });
                    });
                    return;
                }
                if (isQiyeMail) {
                    const { agentEmail: email, password } = bindInfo;
                    const isSubAccount = true;
                    this.doPreLogin(email, isSubAccount, sessionName)
                        .then(res => {
                        if (!res)
                            return true;
                        const eventInfo = {
                            success: false,
                        };
                        if (typeof res === 'object' && res.err) {
                            eventInfo.errMsg = res.errmsg;
                        }
                        else if (typeof res === 'string') {
                            eventInfo.errMsg = res;
                        }
                        else {
                            return true;
                        }
                        resolve(eventInfo);
                        return false;
                    })
                        .then(pass => {
                        if (pass) {
                            this.doLogin({
                                account: email,
                                pwd: password,
                                isSubAccount: true,
                                sessionName,
                            }).then(async (res) => {
                                var _a, _b;
                                let eventInfo = {
                                    success: false,
                                };
                                if (res.pass) {
                                    const uid = res.uid ? res.uid : '';
                                    this.handleAddSubAccountSuccess(uid, resolve, bindInfo);
                                    return;
                                }
                                if (res.errmsg) {
                                    eventInfo.errMsg = res.errmsg;
                                    eventInfo.errCode = 400;
                                }
                                else if (res.secondCheck) {
                                    if (res.showConfig) {
                                        eventInfo.errMsg = '检测到您需要开启二次登录验证，请去Web端开启';
                                        eventInfo.errCode = 500;
                                    }
                                    else if (res.checkType === 'cert') {
                                        eventInfo.errMsg = '当前账号需安装证书，无法进行挂载';
                                        eventInfo.errCode = 800;
                                    }
                                    else {
                                        if (!this.actions.bindSubAccountInfo) {
                                            this.actions.bindSubAccountInfo = {};
                                        }
                                        if (this.actions.bindSubAccountInfo) {
                                            this.actions.bindSubAccountInfo.email = email;
                                            this.actions.bindSubAccountInfo.sessionName = sessionName;
                                            this.actions.bindSubAccountInfo.uid = ((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.res) === null || _b === void 0 ? void 0 : _b.uid) || '';
                                        }
                                        eventInfo.errMsg = res.mobile || '***********';
                                        eventInfo.errCode = 600;
                                    }
                                }
                                else if (res.showResetPass) {
                                    eventInfo.errMsg = '为保障帐户安全，管理员请您修改邮箱密码';
                                    eventInfo.errCode = 700;
                                }
                                else if (res.riskVerify) {
                                    eventInfo.errMsg = '';
                                    eventInfo.errCode = 800;
                                    eventInfo = Object.assign(Object.assign({}, eventInfo), res);
                                }
                                else if (res.showMailMasterDownload) {
                                    eventInfo.errMsg = '当前账号无权限登录灵犀办公客户端';
                                    eventInfo.errCode = 900;
                                }
                                resolve(eventInfo);
                            });
                        }
                    });
                }
            }
            catch (ex) {
                resolve({
                    success: false,
                    errMsg: DEFAULT_API_ERROR,
                    errCode: 101,
                });
            }
        });
    }
    async bindAccountLoginWithCode(code) {
        return new Promise(resolve => {
            var _a;
            if (!this.actions.bindSubAccountInfo) {
                resolve({
                    success: false,
                    errMsg: '获取账号信息失败',
                    errCode: 'LoginWithCode-Error',
                });
                return;
            }
            const sendEmail = ((_a = this.actions.bindSubAccountInfo) === null || _a === void 0 ? void 0 : _a.uid) || this.actions.bindSubAccountInfo.email;
            const sendSessionName = this.actions.bindSubAccountInfo.sessionName;
            this.doLoginWithCode(code, 1, sendEmail, sendSessionName).then(res => {
                const eventData = {
                    success: res.pass,
                };
                if (res.pass) {
                    const uid = res.uid ? res.uid : '';
                    this.handleAddSubAccountSuccess(uid, resolve, this.subAccountBindInfo || SUB_ACCOUNT_TYPES.NETEASE_QIYE_MAIL);
                    return;
                }
                if (res.errmsg) {
                    eventData.errMsg = res.errmsg;
                }
                else if (res.showResetPass) {
                    eventData.errMsg = '为保障帐户安全，管理员请您修改邮箱密码';
                    eventData.errCode = 700;
                }
                else if (res.secondCheck && res.checkType === 'cert') {
                    eventData.errMsg = '当前账号需安装证书，无法进行挂载';
                    eventData.errCode = 800;
                }
                resolve(eventData);
            });
        });
    }
    async sendBindAccountVerifyCode() {
        return new Promise(resolve => {
            var _a;
            if (!this.actions.bindSubAccountInfo) {
                resolve({
                    success: false,
                    errMsg: '获取账号信息失败',
                    errCode: 'SendCode-Error',
                });
                return;
            }
            const sendEmail = this.actions.bindSubAccountInfo.email;
            const sendUid = (_a = this.actions.bindSubAccountInfo) === null || _a === void 0 ? void 0 : _a.uid;
            const sendCodeEmail = sendUid || sendEmail;
            if (sendUid && !this.actions.subAccountCurrentPreLoginRequestMap[sendUid] && sendEmail) {
                this.actions.subAccountCurrentPreLoginRequestMap[sendUid] = this.actions.subAccountCurrentPreLoginRequestMap[sendEmail];
                const uidAccountAndDomain = this.handleAccountAndDomain(sendUid);
                const uidResInfo = this.actions.subAccountCurrentPreLoginRequestMap[sendUid];
                uidResInfo.account = sendUid;
                uidResInfo.account_name = uidAccountAndDomain.account;
                uidResInfo.domain = uidAccountAndDomain.domain;
                uidResInfo.email = sendUid;
            }
            const sendSessionName = this.actions.bindSubAccountInfo.sessionName;
            this.doSendVerifyCode(sendCodeEmail, sendSessionName).then(res => {
                const retVal = {
                    success: !res,
                    errMsg: res,
                    errCode: 300,
                };
                resolve(retVal);
            });
        });
    }
    async bindSubAccount(bindInfo) {
        var _a;
        const { agentEmail } = bindInfo;
        await this.stopBindAccount(agentEmail);
        this.subAccountBindInfo = bindInfo;
        const res = await this.bindSubAccountMail(bindInfo);
        if (!res.success) {
            if (!res.errMsg) {
                res.errMsg = DEFAULT_BIND_ACCOUNT_ERR;
            }
        }
        if (res.success || ((_a = res.errCode) === null || _a === void 0 ? void 0 : _a.toString()) !== '600') {
            await this.stopBindAccount(agentEmail);
        }
        return res;
    }
    async stopBindAccount(email) {
        this.subAccountBindInfo = null;
        const { actions } = this;
        if (actions.bindSubAccountInfo) {
            actions.bindSubAccountInfo = {};
        }
        if (email && actions.bindSubAccountCookieMapInfo) {
            actions.bindSubAccountCookieMapInfo[email] = {};
        }
    }
    getQiyeTokenByEmail(email) {
        if (!email)
            return '';
        const subAccountUser = this.systemApi.getCurrentUser(email);
        let qiyeToken;
        if (subAccountUser && subAccountUser.cookies && subAccountUser.cookies.length) {
            const { cookies } = subAccountUser;
            const qiyeTokenCookie = cookies.find(cookie => cookie.name === 'QIYE_TOKEN' || cookie.name === 'qiye-token');
            if (qiyeTokenCookie && qiyeTokenCookie.value) {
                qiyeToken = qiyeTokenCookie.value;
            }
        }
        return qiyeToken;
    }
    async updateQiyeMailSubAccount(email) {
        var _a;
        try {
            const qiyeToken = this.getQiyeTokenByEmail(email);
            if (!qiyeToken) {
                return {
                    success: false,
                    errMsg: '获取子账号QiyeToken出错',
                    errCode: 201,
                };
            }
            const url = this.systemApi.getUrl('updateSubAccount');
            const res = await this.impl.post(url, { email, relationType: 0, emailQiyeToken: qiyeToken }, Object.assign({}, this.getCommonWebConfig())).then(res => res.data);
            if (!res) {
                return {
                    success: false,
                    errMsg: DEFAULT_API_ERROR,
                    errCode: 200,
                };
            }
            const code = (_a = res.code) === null || _a === void 0 ? void 0 : _a.toString();
            if (code === '200') {
                return {
                    success: true,
                };
            }
            const errCode = res === null || res === void 0 ? void 0 : res.errorCode;
            return {
                success: false,
                errMsg: SUB_ACCOUNT_ERRCODE_MAPS[errCode] || res.error || '更新账号信息失败',
                errCode,
            };
        }
        catch (ex) {
            console.error('updateQiyeMailSubAccount error', ex);
            return {
                success: false,
                errMsg: (ex === null || ex === void 0 ? void 0 : ex.message) || '',
                errCode: 'updateQiyeMailSubAccount-catch',
            };
        }
    }
    async addQiyeMailSubAccount(email) {
        var _a;
        try {
            const qiyeToken = this.getQiyeTokenByEmail(email);
            if (!qiyeToken) {
                return {
                    success: false,
                    errMsg: '获取子账号QiyeToken出错',
                    errCode: 201,
                };
            }
            const url = this.systemApi.getUrl('addSubAccount');
            const res = await this.impl.post(url, { email, relationType: 0, emailQiyeToken: qiyeToken }, Object.assign({}, this.getCommonWebConfig())).then(res => res.data);
            if (!res) {
                return {
                    success: false,
                    errMsg: DEFAULT_API_ERROR,
                    errCode: 200,
                };
            }
            const code = (_a = res.code) === null || _a === void 0 ? void 0 : _a.toString();
            if (code === '200') {
                return {
                    success: true,
                };
            }
            const errCode = res === null || res === void 0 ? void 0 : res.errorCode;
            if (errCode === 'ACCOUNT.LOGINREF.CREATE.OVERFLOW') {
                this.sendAgentAccountLimitToServer();
            }
            return {
                success: false,
                errMsg: SUB_ACCOUNT_ERRCODE_MAPS[errCode] || res.error || DEFAULT_BIND_ACCOUNT_ERR,
                errCode,
            };
        }
        catch (ex) {
            console.error('addQiyeMailSubAccount error', ex);
            return {
                success: false,
                errMsg: (ex === null || ex === void 0 ? void 0 : ex.message) || '',
                errCode: 'addQiyeMailSubAccount-catch',
            };
        }
    }
    getBindAccountErrorMsg(res) {
        const errorCode = res === null || res === void 0 ? void 0 : res.errorCode;
        const errorMsg = errorCode ? SUB_ACCOUNT_ERRCODE_MAPS[errorCode] || (res === null || res === void 0 ? void 0 : res.err_msg) || DEFAULT_API_ERROR : DEFAULT_API_ERROR;
        return errorMsg;
    }
    getCommonWebConfig() {
        return {
            headers: COMMON_WEB_HEADER,
        };
    }
    async addPersonalMailSubAccount(bindInfo) {
        var _a;
        try {
            const url = this.systemApi.getUrl('addSubAccount');
            const sendData = {
                agent_email: bindInfo.agentEmail,
                agent_nickname: bindInfo.agentNickname,
                password: bindInfo.password,
                send_host: bindInfo.sendHost,
                send_port: bindInfo.sendPort,
                send_ssl: bindInfo.sendSsl,
                receive_protocol: bindInfo.receiveProtocol,
                receive_host: bindInfo.receiveHost,
                receive_ssl: bindInfo.receiveSsl,
                receive_port: bindInfo.receivePort,
                relationType: 1,
            };
            const result = await this.impl.post(url, sendData, Object.assign({}, this.getCommonWebConfig())).then(res => res.data);
            if (((_a = result === null || result === void 0 ? void 0 : result.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                return {
                    success: true,
                };
            }
            if ((result === null || result === void 0 ? void 0 : result.errorCode) === 'AGENTACCOUNT.CREATE.BIND.OVERFLOW') {
                this.sendAgentAccountLimitToServer();
            }
            return {
                success: false,
                errCode: result === null || result === void 0 ? void 0 : result.errorCode,
                errMsg: this.getBindAccountErrorMsg(result),
            };
        }
        catch (ex) {
            return {
                success: false,
                errCode: 'addPersonalMailSubAccount-catch',
                errMsg: ex.message,
            };
        }
    }
    fillSubAccountInfo(res, agentEmail, isThirdAccount, sessionName) {
        if (res && res.data) {
            res.data.isSubAccount = true;
            res.data.isThirdAccount = isThirdAccount;
            res.data.agentEmail = agentEmail;
            res.data.sessionName = sessionName;
        }
    }
    async loginAgentEmail(email, sessionName, setCookieSessionName, relationType, isCheck) {
        var _a;
        try {
            const url = this.systemApi.getUrl('loginSubAccount');
            const urlParamArr = process.env.BUILD_ISELECTRON
                ? [sessionName ? '_session=' + sessionName : '', setCookieSessionName ? '_setsession=' + setCookieSessionName : ''].filter(item => item)
                : [];
            const req = {
                relationType,
                email,
                p: 'sirius-desktop',
                output: 'json',
                autoEntry: true,
            };
            if (process.env.BUILD_ISWEB) {
                this.fillAutoEntryAndNoCookieInfo(req);
            }
            const isThirdAccount = relationType !== SUBACCOUNT_LOGINTYPE.NETEASE_QIYE_MAIL;
            if (!isThirdAccount) {
                this.fillSecRequestInfo(req);
            }
            const result = await this.impl.post(url + `${urlParamArr && urlParamArr.length ? '?' + urlParamArr.join('&') : ''}`, req).then(res => res.data);
            if (((_a = result === null || result === void 0 ? void 0 : result.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                if (isCheck) {
                    return {
                        success: true,
                    };
                }
                this.fillSubAccountInfo(result, email, isThirdAccount, setCookieSessionName);
                const ret = await this.processLoginResult(result);
                const uid = ret.uid || '';
                return {
                    success: ret.pass,
                    errCode: ret.errCode,
                    errMsg: ret.errmsg,
                    data: {
                        email: uid,
                    },
                };
            }
            return {
                success: false,
                errCode: result === null || result === void 0 ? void 0 : result.msgCode,
                errMsg: result === null || result === void 0 ? void 0 : result.msgCodeDesc,
            };
        }
        catch (ex) {
            return {
                success: false,
                errCode: 'loginAgentEmail-catch',
                errMsg: ex.message,
            };
        }
    }
    sendAgentAccountLimitToServer() {
        this.dataTrackApi.track('pcMail_limit_LoginDetailPage_agent');
    }
    async getMailClientConfig(mailDomain) {
        var _a;
        try {
            const url = process.env.BUILD_ISWEB ? config('getMailClientConfig') : this.systemApi.getUrl('getMailClientConfig');
            const result = await this.impl.get(url, { domain: mailDomain }).then(res => res.data);
            if (((_a = result === null || result === void 0 ? void 0 : result.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                return result.data;
            }
            return null;
        }
        catch (ex) {
            console.log('getMailClientConfig-catch', ex);
            return null;
        }
    }
    static waitTime(time) {
        return new Promise(resolve => {
            setTimeout(resolve, time);
        });
    }
    async getQRCodeStatus(uuid) {
        try {
            let qrCodeUuid;
            if (!uuid) {
                const cookies = await this.systemApi.doGetCookies(true);
                qrCodeUuid = cookies.miniapp_qrcode_uuid;
            }
            else {
                qrCodeUuid = uuid;
            }
            if (!qrCodeUuid) {
                return {
                    success: false,
                    errCode: 'No-QrCode-Uuid',
                    errMsg: '未获取到二维码Id，请刷新',
                };
            }
            const res = await this.impl.get(this.systemApi.getUrl('qrcodeCheck'), { p: 'sirius', uuid: qrCodeUuid }).then(res => res.data);
            if (!(res === null || res === void 0 ? void 0 : res.suc)) {
                return {
                    success: false,
                    errCode: res === null || res === void 0 ? void 0 : res.error_code,
                    errMsg: res === null || res === void 0 ? void 0 : res.error_msg,
                };
            }
            if (res.con) {
                const conData = res.con;
                if (conData.node) {
                    this.setupNodeInfo(conData.node);
                }
                let errMsg = '';
                if (conData.loginMsg) {
                    errMsg = LoginApiImpl.getErrMsg(conData.loginMsg);
                }
                const result = {
                    success: !errMsg,
                    errMsg,
                    data: {
                        uuid: conData.uuid,
                        status: conData.status,
                        loginUrl: conData.loginUrl,
                        node: conData.node,
                        loginSuc: conData.loginSuc,
                        loginMsg: errMsg,
                    },
                };
                return result;
            }
            return {
                success: false,
                errCode: 'No-Con-Data',
                errMsg: '没有Con数据，请刷新',
            };
        }
        catch (ex) {
            console.error('getQRCodeStatus Error', ex);
            return {
                success: false,
                errCode: 'Catch',
            };
        }
    }
    async loginByQRCode(loginUrl, node) {
        var _a, _b, _c;
        try {
            const domainIndex = loginUrl.indexOf('/domain');
            let loginPath = domainIndex >= 0 ? loginUrl.substring(domainIndex) : '';
            if (!loginPath) {
                return {
                    pass: false,
                    errCode: 'no-login-path',
                    errmsg: '获取登录信息失败',
                };
            }
            loginPath += '&autoEntry=true';
            const isDomesticHostType = this.systemApi.getIsDomesticHostType();
            const newLoginUrl = `${process.env.BUILD_ISWEB ? '' : isDomesticHostType ? config('domesticHost') : config('host')}${node === 'bj' ? loginPath.replace('/domain', '/bjdomain') : loginPath}`;
            const loginParams = {};
            this.fillSecRequestInfo(loginParams);
            const loginRes = await this.impl.post(newLoginUrl, loginParams).then(res => res.data);
            const ret = await this.processLoginResult(loginRes);
            if (ret.pass) {
                const loginUid = (_a = loginRes === null || loginRes === void 0 ? void 0 : loginRes.data) === null || _a === void 0 ? void 0 : _a.uid;
                if (loginUid) {
                    await this.tryReportLoginSuccess(loginUid);
                }
            }
            else if (ret.secondCheck) {
                if (ret.checkType === 'mobile') {
                    ret.errmsg = '需要二次验证，请使用其它方式登录';
                }
                if (ret.checkType === 'mail') {
                    ret.errmsg = '需要二次验证，请使用其它方式登录';
                }
            }
            else if ((ret === null || ret === void 0 ? void 0 : ret.res) && ((_b = ret === null || ret === void 0 ? void 0 : ret.res) === null || _b === void 0 ? void 0 : _b.location) === 'crisk') {
                const path = newLoginUrl.split('?')[1];
                let searchParams = new URLSearchParams(path || '');
                const obj = Object.create(null);
                for (const [k, v] of searchParams) {
                    obj[k] = v;
                }
                obj.uid && (this.actions.currentLoginRisk[obj.uid] = true);
                return {
                    pass: false,
                    riskVerify: true,
                    errmsg: '',
                    redirect: RiskPrefix + ((_c = ret === null || ret === void 0 ? void 0 : ret.res) === null || _c === void 0 ? void 0 : _c.redirect),
                    originReq: {
                        urlParam: obj,
                        req: Object.assign({}, loginParams),
                        email: obj.uid,
                    },
                };
            }
            return ret;
        }
        catch (ex) {
            console.error('QRCodeLogin-error', ex);
            return {
                pass: false,
                errCode: 'catch',
                errmsg: ex.message,
            };
        }
    }
    async qrcodeCheck(uuid, maxN = 720) {
        let qrCookie = uuid;
        if (!uuid) {
            const cookies = await this.systemApi.doGetCookies(true);
            qrCookie = cookies.miniapp_qrcode_uuid;
        }
        if (maxN === 0) {
            return {
                success: false,
                errMsg: `超时${maxN / 2}次`,
            };
        }
        return this.impl
            .get(this.getUrl('qrcodeCheck'), { p: 'sirius', uuid: qrCookie })
            .then(async (rs) => {
            const resData = rs.data;
            if (!(resData === null || resData === void 0 ? void 0 : resData.suc)) {
                return {
                    success: false,
                    errMsg: resData === null || resData === void 0 ? void 0 : resData.error_msg,
                    errCode: resData === null || resData === void 0 ? void 0 : resData.error_code,
                };
            }
            if (resData.con) {
                if (resData.con.status === QrCheckStatus.init || resData.con.status === QrCheckStatus.scaning) {
                    await LoginApiImpl.waitTime(1000);
                    return this.qrcodeCheck(qrCookie, maxN - 1);
                }
                return {
                    success: true,
                    data: resData.con,
                };
            }
            return {
                success: false,
            };
        })
            .catch(reason => {
            console.log('[login] qrcodeCheck check error', reason);
            return {
                success: false,
                errMsg: `${reason}`,
            };
        });
    }
    getLoginQrCodeImgUrl(params) {
        const imgWidth = params && params.w ? params.w : 200;
        const imgHeight = params && params.h ? params.h : 200;
        const type = inWindow() && window && window.electronLib ? 7 : 6;
        return this.systemApi.getUrl('qrCodeCreate') + `?w=${imgWidth}&h=${imgHeight}&type=${type}&ts=${new Date().getTime()}`;
    }
    customHostSwitchSharedAccount(account, domain) {
        try {
            const switchHost = `${location.protocol}//${location.host}`;
            const isHttps = location.protocol && location.protocol.includes('https');
            location.href = switchHost + `/login/sharedSwitchLogin?account_name=${account}&domain=${domain}&autoEntry=true${isHttps ? '&all_secure=1' : ''}`;
            return {
                success: true,
            };
        }
        catch (ex) {
            return {
                success: false,
                errCode: 'customHostSwitchSharedAccount-catcherror',
                errMsg: '切换公共账号失败',
            };
        }
    }
    async switchSharedAccount(email, noReload) {
        var _a;
        try {
            const emailInfo = this.handleAccountAndDomain(email);
            if (!emailInfo.account || !emailInfo.domain) {
                return {
                    success: false,
                    errCode: 'ParamError',
                    errMsg: '参数错误，邮箱格式错误',
                };
            }
            if (process.env.BUILD_ISWEB && process.env.BUILD_ISLINGXI) {
                const isCustomHost = this.systemApi.getIsWebCustomHost();
                if (isCustomHost) {
                    return this.customHostSwitchSharedAccount(emailInfo.account, emailInfo.domain);
                }
            }
            let isSharedAccountLogin = false;
            let sharedAccountInfo = null;
            let originAccount = '';
            if (!noReload) {
                sharedAccountInfo = await this.accountApi.getSharedAccountsInfoAsync();
                if (sharedAccountInfo) {
                    isSharedAccountLogin = sharedAccountInfo.isSharedAccountLogin;
                    originAccount = sharedAccountInfo.isSharedAccountLogin && !sharedAccountInfo.isSharedAccountExpired ? sharedAccountInfo.email : '';
                }
            }
            const url = this.systemApi.getUrl('switchSharedAccount');
            if (!noReload) {
                this.systemApi.switchLoading(true);
                this.disableBackgroundDB();
                this.impl.setLogoutStatus(true);
                this.noLoginEvent = true;
                if (process.env.BUILD_ISELECTRON) {
                    try {
                        await window.electronLib.windowManage.closeAllWindowExceptMain(true);
                    }
                    catch (ex) {
                        console.error('closeAllWindowExceptMain error', ex);
                    }
                }
            }
            const reqestData = Object.assign(Object.assign({}, defaultLoginInfo), { account_name: emailInfo.account, domain: emailInfo.domain, autoEntry: true });
            this.fillSecRequestInfo(reqestData);
            const resData = await this.impl.get(url, reqestData, noHeaderTokenConfig).then(res => res.data);
            if (!resData || !resData.data) {
                return {
                    success: false,
                };
            }
            if (noReload || ((_a = sharedAccountInfo === null || sharedAccountInfo === void 0 ? void 0 : sharedAccountInfo.sharedAccounts) === null || _a === void 0 ? void 0 : _a.some(item => item.email === email))) {
                resData.data.isSharedAccountSwitch = true;
            }
            else {
                resData.data.isSharedAccountSwitch = !isSharedAccountLogin;
            }
            resData.data.originAccount = originAccount;
            const currentNode = this.storeApi.getCurrentNode();
            if (currentNode && currentNode !== this.actions.currentNode) {
                this.actions.currentNode = currentNode;
            }
            resData.data.noEnableBackDb = true;
            if (resData.msgCode === NO_LOGIN_RIGHTS_CODE) {
                resData.msgCode = '该公共账号无网易灵犀办公客户端登录权限，如需使用请联系管理员。';
            }
            const loginResult = await this.processLoginResult(resData);
            if (!loginResult || !loginResult.pass) {
                if (!process.env.BUILD_ISELECTRON) {
                    if (loginResult.shouldRedirect) {
                        if (loginResult.redirectUrl) {
                            location.replace(loginResult.redirectUrl);
                            return {
                                success: true,
                            };
                        }
                    }
                }
                if (!noReload) {
                    this.enableBackgroundDB();
                    this.systemApi.switchLoading(false);
                    this.impl.setLogoutStatus(false);
                    this.noLoginEvent = false;
                }
                return {
                    success: false,
                    errCode: loginResult.errCode || resData.msgCode,
                    errMsg: loginResult.errmsg,
                };
            }
            if (window) {
                if (!noReload) {
                    this.systemApi.switchLoading(true);
                    if (process.env.BUILD_ISELECTRON) {
                        setTimeout(() => {
                            this.createBKStableWindow();
                        }, 0);
                        await wait(300);
                    }
                    this.systemApi.reloadToMainPage();
                }
            }
            return {
                success: true,
            };
        }
        catch (ex) {
            this.systemApi.switchLoading(false);
            this.enableBackgroundDB();
            this.impl.setLogoutStatus(false);
            this.noLoginEvent = false;
            console.error('switchSharedAccount error', ex);
            const res = {
                success: false,
                errCode: 'Catch-Error',
                errMsg: ex.message,
            };
            return res;
        }
    }
    getLoginCode() {
        const url = this.systemApi.getUrl('getLoginCode');
        return this.impl.get(url).then((rs) => {
            const resData = rs.data;
            if ((resData === null || resData === void 0 ? void 0 : resData.code) === 0 && (resData === null || resData === void 0 ? void 0 : resData.data)) {
                return resData.data;
            }
            return '';
        });
    }
    getEntranceVisibleConfig() {
        const url = this.systemApi.getUrl('getEntranceVisibleConfig');
        return this.impl.get(url).then((rs) => {
            const resData = rs.data;
            if ((resData === null || resData === void 0 ? void 0 : resData.code) === 0 && (resData === null || resData === void 0 ? void 0 : resData.data)) {
                return {
                    showTab: resData.data.show,
                    showPopup: resData.data.showPopup,
                };
            }
            return {
                showTab: false,
                showPopup: false,
            };
        });
    }
    setEntrancePopupVisible(source) {
        const url = this.systemApi.getUrl('setEntrancePopupVisible');
        return this.impl.post(url, { source }).then((rs) => {
            const resData = rs.data;
            return (resData === null || resData === void 0 ? void 0 : resData.code) === 0 && !!(resData === null || resData === void 0 ? void 0 : resData.data);
        });
    }
    resetLoginState() {
        this.impl.setLogoutStatus(false);
        this.systemApi.switchLoading(false);
        this.enableBackgroundDB();
    }
    async setStateBeforeSwitchLogin() {
        this.systemApi.switchLoading(true);
        this.impl.setLogoutStatus(true);
        this.disableBackgroundDB();
        if (process.env.BUILD_ISELECTRON) {
            try {
                await window.electronLib.windowManage.closeAllWindowExceptMain(true);
            }
            catch (ex) {
                console.error('closeAllWindowExceptMain error', ex);
            }
        }
    }
    async createNewAccountBkStableWindow(noEnableDb) {
        try {
            if (process.env.BUILD_ISELECTRON) {
                setTimeout(() => {
                    this.createBKStableWindow();
                }, 0);
                await wait(300);
            }
            if (noEnableDb) {
                this.enableBackgroundDB();
            }
        }
        catch (ex) {
            console.error('ex');
        }
    }
    async doAutoLoginInCurrentPage(email, shouldReload) {
        const defaultErrorRes = {
            pass: false,
            errmsg: '',
        };
        try {
            if (!email) {
                return defaultErrorRes;
            }
            await this.setStateBeforeSwitchLogin();
            const res = await this.doAutoLogin(email, true, true);
            if (!res.pass) {
                this.resetLoginState();
                return res;
            }
            await this.createNewAccountBkStableWindow(true);
            if (shouldReload) {
                this.systemApi.reloadToMainPage();
            }
            else {
                this.resetLoginState();
            }
            return res;
        }
        catch (ex) {
            this.resetLoginState();
            console.error('doAutoLoginInCurrentPage-error', ex);
            return defaultErrorRes;
        }
    }
    async sendSelfUnBlockingCode() {
        try {
            const url = this.impl.buildUrl(this.getUrl('sendCode'), Object.assign(Object.assign({}, (this.actions && this.actions.currentPreloginRequest ? this.actions.currentPreloginRequest : {})), { output: 'json', type: 3 }));
            return this.impl
                .get(url, {}, {})
                .then(this.unpackLoginData.bind(this))
                .then(({ code, msgCode }) => {
                if (String(code) === '200') {
                    return {
                        success: true,
                    };
                }
                const errorStr = msgCode === 'ERR.LOGIN.MLOGINSMSREQ' ? '今日此手机验证码获取次数已达到上限' : LoginApiImpl.getErrMsg(msgCode) || SEND_CODE_DEFAULT_ERROR;
                return {
                    success: false,
                    errMsg: errorStr,
                };
            })
                .catch(reason => {
                console.error(reason);
                return {
                    success: false,
                    errMsg: SEND_CODE_DEFAULT_ERROR,
                };
            });
        }
        catch (ex) {
            return {
                success: false,
                errMsg: SEND_CODE_DEFAULT_ERROR,
            };
        }
    }
    async selfUnBlockingWithCode(code) {
        try {
            const url = this.getUrl('selfUnBlocking');
            return this.impl
                .post(url, {
                p: productCode,
                code,
                output: 'json',
            })
                .then(this.unpackLoginData.bind(this))
                .then(res => {
                if (res && res.code && res.code.toString() === '200') {
                    return {
                        success: true,
                    };
                }
                const msgCode = res.msgCode || '';
                const errorMsg = msgCode ? LoginApiImpl.getErrMsg(msgCode, SELF_UNBLOCK_DEFAULT_ERROR) : SELF_UNBLOCK_DEFAULT_ERROR;
                return {
                    success: false,
                    errMsg: errorMsg,
                };
            })
                .catch(err => {
                console.error(err);
                return {
                    success: false,
                    errMsg: SELF_UNBLOCK_DEFAULT_ERROR,
                };
            });
        }
        catch (ex) {
            console.error(ex);
            return {
                success: false,
                errMsg: SELF_UNBLOCK_DEFAULT_ERROR,
            };
        }
    }
    async sendUnBlockingEmailToAdmin() {
        try {
            const url = this.getUrl('applyUnBlocking');
            return this.impl
                .post(url, {
                p: productCode,
                output: 'json',
            })
                .then(this.unpackLoginData.bind(this))
                .then(res => {
                if (res && res.code && res.code.toString() === '200') {
                    return {
                        success: true,
                    };
                }
                const msgCode = res.subMsgCode || res.msgCode || '';
                const errorMsg = msgCode ? LoginApiImpl.getErrMsg(msgCode, SELF_UNBLOCK_DEFAULT_ERROR) : SELF_UNBLOCK_DEFAULT_ERROR;
                return {
                    success: false,
                    errMsg: errorMsg,
                };
            })
                .catch(err => {
                console.error(err);
                return {
                    success: false,
                    errMsg: SELF_UNBLOCK_DEFAULT_ERROR,
                };
            });
        }
        catch (ex) {
            console.error(ex);
            return {
                success: false,
                errMsg: SELF_UNBLOCK_DEFAULT_ERROR,
            };
        }
    }
    getLoginVefifyCodeUrl() {
        return this.getUrl('loginQrCode') + `?rnd=${new Date().getTime()}`;
    }
    async getCWSecDeviceInfo() {
        var _a;
        try {
            const url = this.getUrl('CWGetSecDeviceInfo');
            const macAddressInfo = await this.systemApi.getDeviceMacInfo();
            if (!macAddressInfo)
                return null;
            const localMacAddress = macAddressInfo.macAddress;
            const res = await this.impl.get(url, { secMdc: localMacAddress.join(',') }).then(res => res.data);
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200' && res.result) {
                const { orgOpen } = res.result;
                if (!orgOpen) {
                    return {
                        status: 'NOT-OPEN',
                    };
                }
                const scopeMemberList = res.result.scopeMemberList || [];
                const deviceInfo = res.result.deviceInfo;
                const auditInfo = res.result.auditInfo;
                if (auditInfo && auditInfo.audit_status === 0 && deviceInfo) {
                    deviceInfo.belong_scope = auditInfo.apply_belong_scope;
                }
                const dataDeviceInfo = transferLocalDeviceToServerDevice(transferCWServiceDeviceInfoToLocalDevice(deviceInfo));
                if (auditInfo) {
                    if (auditInfo.audit_status === 0) {
                        return {
                            status: 'REPORTING',
                            data: dataDeviceInfo,
                        };
                    }
                    if (auditInfo.audit_status === 1) {
                        return {
                            status: 'REPORTED',
                            data: dataDeviceInfo,
                        };
                    }
                    if (auditInfo.audit_status === 2) {
                        return {
                            status: 'REJECTED',
                            data: dataDeviceInfo,
                        };
                    }
                    if (auditInfo.audit_status === 3) {
                        return {
                            status: 'ERROR',
                            data: dataDeviceInfo,
                        };
                    }
                }
                else {
                    let reportStatusStr = 'NEED-REPORT';
                    if (dataDeviceInfo) {
                        if (dataDeviceInfo.secBelongScope === 0 && scopeMemberList && scopeMemberList.length) {
                            const currentUser = this.systemApi.getCurrentUser();
                            if (currentUser) {
                                if (scopeMemberList.includes(currentUser.id) || scopeMemberList.includes(currentUser.loginAccount)) {
                                    reportStatusStr = 'REPORTED';
                                }
                            }
                        }
                        else if (dataDeviceInfo.secBelongScope === 1) {
                            reportStatusStr = 'REPORTED';
                        }
                    }
                    return {
                        status: reportStatusStr,
                        data: dataDeviceInfo,
                    };
                }
            }
            return null;
        }
        catch (ex) {
            console.error('getCWSecDeviceInfo-catch', ex);
            return null;
        }
    }
    async reportCWDeviceInfo(deviceInfo) {
        var _a;
        const defaultErrorMsg = '上报设备信息出错';
        try {
            const url = this.getUrl('CWReportSecDeviceInfo');
            const deviceData = transferLocalDeviceToCWServerDevice(transferServerDeviceToLocalDevice(deviceInfo));
            const res = await this.impl
                .post(url, {
                secMdc: deviceData.mdc,
                scope: deviceData.belong_scope,
            })
                .then(res => res.data);
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                return {
                    success: true,
                };
            }
            const errorCode = res === null || res === void 0 ? void 0 : res.errorCode;
            const codeMap = {
                'SEC.DEVICE.APPLY.PENDING.EXIST': '该设备已申请，请等待审核',
            };
            return {
                success: false,
                errMsg: codeMap[errorCode] || defaultErrorMsg,
            };
        }
        catch (ex) {
            console.error('getSecDeviceInfo-error', ex);
            return {
                success: false,
                errMsg: ex && ex.message ? ex.message : defaultErrorMsg,
            };
        }
    }
    async getSecDeviceInfo() {
        var _a;
        const defaultErrorMsg = '获取服务端设备信息出错';
        try {
            const url = this.getUrl('loginGetSecDeviceInfo');
            const macAddressInfo = await this.systemApi.getDeviceMacInfo();
            if (!macAddressInfo)
                return null;
            const localMacAddress = macAddressInfo.macAddress;
            const res = await this.impl.get(url, { secMdc: localMacAddress.join(',') }).then(res => res.data);
            const needReportRes = {
                status: 'NEED-REPORT',
            };
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                const serverDevice = res.data;
                const localDevice = await this.systemApi.getDeviceMacInfo();
                if (!serverDevice) {
                    return Object.assign(Object.assign({}, needReportRes), { data: localDevice ? transferLocalDeviceToServerDevice(localDevice) : undefined });
                }
                const mergeDevice = Object.assign(localDevice ? transferLocalDeviceToServerDevice(localDevice) : {}, serverDevice);
                if (serverDevice.secAuditing) {
                    return {
                        status: 'REPORTING',
                        data: mergeDevice,
                    };
                }
                return Object.assign(Object.assign({}, needReportRes), { data: serverDevice });
            }
            return {
                status: 'ERROR',
                errorMsg: (res === null || res === void 0 ? void 0 : res.msgCodeDesc) || defaultErrorMsg,
            };
        }
        catch (ex) {
            console.error('getSecDeviceInfo-error', ex);
            return {
                status: 'ERROR',
                errorMsg: ex && ex.message ? ex.message : defaultErrorMsg,
            };
        }
    }
    async reportSecDeviceInfo(deviceInfo) {
        var _a;
        const defaultErrorMsg = '上报设备信息出错';
        try {
            const url = this.getUrl('loginReportSecDeviceInfo');
            const res = await this.impl.post(url, Object.assign(Object.assign({}, deviceInfo), { sec: true })).then(res => res.data);
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                return {
                    success: true,
                };
            }
            return {
                success: false,
                errMsg: (res === null || res === void 0 ? void 0 : res.msgCodeDesc) || defaultErrorMsg,
            };
        }
        catch (ex) {
            console.error('getSecDeviceInfo-error', ex);
            return {
                success: false,
                errMsg: ex && ex.message ? ex.message : defaultErrorMsg,
            };
        }
    }
    async logoutInOtherApp() {
        try {
            const urlMap = {
                dingding: 'https://open.qiye.163.com/miniapp/dingding/unbind',
                qiye_weixin: 'https://open.qiye.163.com/miniapp/qiye_weixin/unbind',
                feishu: 'https://open.qiye.163.com/miniapp/feishu/removeBindInfo',
            };
            let url = '';
            if (window.isInDingTalk) {
                url = urlMap['dingding'];
            }
            else if (window.isInWxWork) {
                url = urlMap['qiye_weixin'];
            }
            else if (window.isInFeiShu) {
                url = urlMap['feishu'];
            }
            if (!url) {
                console.error('url not found');
                return;
            }
            fetch(url, { credentials: 'include' })
                .then(res => res.json())
                .then(jsonRes => {
                document.body.innerHTML =
                    jsonRes.suc === !0
                        ? '<h1 style="font-size:20px;padding:10px;">帐号已退出登录，请关闭当前页面...</h1>'
                        : '<h1 style="font-size:20px;padding:10px">解绑失败，请联系客服-</h1>' + jsonRes.error_code;
            });
        }
        catch (ex) {
            console.error(ex);
            return;
        }
    }
}
LoginApiImpl.accountPwdAutoFilled = config('accountPwdAutoFilled');
LoginApiImpl.maxLoginNoRefreshSpan = 1800000;
LoginApiImpl.isInited = false;
LoginApiImpl.defaultErrInfo = ErrMsgCodeMap['SERVER.ERR'];
LoginApiImpl.keyDeviceUUID = config('browerDeviceUUID');
LoginApiImpl.edmLoginReportKey = 'edmLoginReportKey';
LoginApiImpl.edmLoginReportMax = 5;
LoginApiImpl.storeConfig = globalStoreConfig;
const loginApiImpl = new LoginApiImpl();
api.registerLogicalApi(loginApiImpl);
export default loginApiImpl;
